import { __spreadArray, __awaiter, __generator, __assign, __extends, __decorate, __metadata } from 'tslib';
import * as ThumbPlayerCore from '@tencent/thumbplayer-core';
import { defaultI18nConfig, uaTool, Logger, PLAY_EVENT, commonTool, cookieTool, urlTool, i18nConfig, t, PLAY_MODE as PLAY_MODE$1, PLAYER_LOG_LEVEL, domTool, VIDEO_CODEC, KERNEL_NAME, ERROR_CODE, lsTool, CoreStepKey, KernelStepKey, KernelFactory, logMethodCallDecoratorCreator, performanceCostDecoratorCreator, ReferenceReport, destroyProtectDecorator, mountGlobal, SET_LEVEL_MODE } from '@tencent/thumbplayer-core';
import * as ThumbPlayerH5 from '@tencent/thumbplayer-h5';
import { AD_TYPE, AdPluginName, getAdPlugin, H5_PLAY_EVENT, H5_EXT_EVENT, ErrorCode, PLAY_MODE, AUTO_PLAY_POLICY, END_STATE, COMMON_DATA_KEY, BaseCheck, CheckNormalError, StepTimer, BaseReporter, H5Player, StepKey, hasGetinfoModule, VIDEO_STATE, PersistedUserSettings, getAdReqParams, LOCAL_KEY } from '@tencent/thumbplayer-h5';
export * from '@tencent/thumbplayer-h5';
export { H5_EXT_EVENT as PLAY_EVENT_EXT } from '@tencent/thumbplayer-h5';
import { LivepollPlugin, LIVE_EVENTS, LIVE_STATUS } from '@tencent/thumbplayer-plugin-live-poll';
import { UILoadingPlugin } from '@tencent/thumbplayer-plugin-ui-loading';
import * as TVK from '@tencent/thumbplayer-tvk';
import { convertCapabilityConfig2String, PLAYER_COOKIE, getAllCapabilityConfig, HEVC_LV_VALUE, FORMAT, O266_LV_VALUE, TvkStepKey, getDefaultVodPlatform, getDefautVodSdtfrom, OfficialPlatform, isOfficialSite, PAID_FORMAT, getLogintoken, enableTVK, requestVideoExtInfo, ProxyHttp, getUserCookies, COOKIE_NAME, PLAY_CODEC, getLiveBuiltInVideoReqInfoParam, getVodBuiltInVideoReqInfoParam, VodGetinfo, LiveGetinfo } from '@tencent/thumbplayer-tvk';
export { CKEY_VRE, PAID_FORMAT, PLAY_CODEC } from '@tencent/thumbplayer-tvk';
import { CtrlbarPlugin, PlayBtnStatus, CTRL_EVENTS, CTRL_SIZE } from '@tencent/thumbplayer-plugin-ctrlbar';
export { CTRL_EVENTS, CTRL_SIZE, PlayBtnStatus } from '@tencent/thumbplayer-plugin-ctrlbar';
import { ErrorPagePlugin } from '@tencent/thumbplayer-plugin-error-page';
import { InfoPanelPlugin } from '@tencent/thumbplayer-plugin-info-panel';
import { PosterPlugin } from '@tencent/thumbplayer-plugin-poster';
import { TipsPlugin } from '@tencent/thumbplayer-plugin-tips';
import { UIContextMenuPlugin } from '@tencent/thumbplayer-plugin-ui-contextmenu';
import { WatermarkPlugin } from '@tencent/thumbplayer-plugin-watermark';
import { isMobile } from '@tencent/thumbplayer-plugin-utils';

var superPlayerI18nConfig = {
    // Tips 插件文案
    TIPS_DEGRADE_TEXT_REASON: '正在缓冲中...',
    TIPS_DEGRADE_TEXT_NO_REASON: '重新请求视频信息...',
    // ErrorPage 文案
    ERROR_PAGE_REPORT_SUCCESS: '日志上报成功',
    ERROR_PAGE_REPORT_FAILED: '日志上报失败 $0',
    // 清晰度切换文案
    DEFN_SWITCHING: '正在为您切换清晰度[$0]',
    DEFN_SWITCH_FAILED: '抱歉，切换清晰度失败~',
    DEFN_SWITCH_SUCCESS: '已为您切换到清晰度[$0]',
    // 音轨切换文案
    AUDIO_SWITCHING: '正在为您切换音轨[$0]',
    AUDIO_SWITCH_FAILED: '抱歉，切换音轨失败~',
    AUDIO_SWITCH_SUCCESS: '已为您切换到音轨[$0]',
    // 直播结束文案
    LIVE_STREAM_END: '直播已结束',
    // SuperPlayer load 接口参数检查错误
    ERROR_EMPTY_PARAM: '传入的参数为空',
    ERROR_LOAD_PARAM_NOT_SUPPORT: '直播模式不支持load()接口',
    ERROR_VID_NOT_SUPPORT: '直播模式不支持传入vid',
    ERROR_CNLID_NOT_SUPPORT: '点播模式不支持传入cnlid',
    ERROR_VID_INVALID: 'vid参数非法',
    // 试看
    PREVIEW_TIPS: '可试看 $0，去腾讯视频观看完整版 <a target="_blank;" href="$1">立即前往</a>',
};
defaultI18nConfig.superPlayer = superPlayerI18nConfig;

/** 桌面端使用的广告插件版本号 */
var webAdVersion = '3.4.10';
/** 移动端使用的广告插件版本号 */
var h5AdVersion = '3.4.10';
/** 广告插件全局变量名 */
var adGlobalName = 'CreativePlayerPlugin';
/** 广告cdn版本号 */
var adVersion = uaTool.mobile ? h5AdVersion : webAdVersion;
/** 广告js最大加载时长 */
var adScriptMaxLoadTime = 10e3;
function getAdPluginPath(adVersion) {
    var fileName = "creative-player-".concat(uaTool.mobile ? 'm' : 'v', ".js");
    return "https://vm.gtimg.cn/thumbplayer/creative/".concat(adVersion, "/").concat(fileName, "?max_age=7776000");
}

/** 免前贴广告 域名白名单 */
var skipAdDomainWhiteList = [
    // 新闻插件的量很大，广告侧要求直接根据域名屏蔽前贴
    'e.news.qq.com',
];
var isInDomainWhiteList = skipAdDomainWhiteList.includes(window.location.hostname);

var CtrlbarPluginName = CtrlbarPlugin.pluginName;
var ErrorPagePluginName = ErrorPagePlugin.pluginName;
var InfoPanelPluginName = InfoPanelPlugin.pluginName;
var PosterPluginName = PosterPlugin.pluginName;
var TipsPluginName = TipsPlugin.pluginName;
var UIContextMenuPluginName = UIContextMenuPlugin.pluginName;
var WatermarkPluginName = WatermarkPlugin.pluginName;
var ErrorPagePluginEvents = ErrorPagePlugin.Events;
/**
 * @deprecated
 * 历史原因存在，此导出可能被删除
 */
var PLUGINS_URL = 'https://vm.gtimg.cn/thumbplayer/plugins/thumbplayer-plugin-super-player-plugins/latest/index.min.js';

var SuperStepKey;
(function (SuperStepKey) {
    /** 从模块ready到new播放器的流程 */
    SuperStepKey["READY_2_NEW"] = "ready2new";
    SuperStepKey["NEW"] = "new";
    /** 从new播放器到调用play接口的流程 */
    SuperStepKey["NEW_2_PLAY"] = "new2play";
    /** 首缓（广告或者正片起播） */
    SuperStepKey["FIRST_PLAYING"] = "firstPlaying";
    SuperStepKey["PREPARE_REQ"] = "prepareReq";
    SuperStepKey["LOAD_AD_PLUGIN"] = "loadAdPlugin";
})(SuperStepKey || (SuperStepKey = {}));
/**
 * 在superplayer这一层定义的播放结束状态枚举
 */
var SUPER_END_STATE;
(function (SUPER_END_STATE) {
    /** 试看结束 */
    SUPER_END_STATE["PREVIEW"] = "preview";
})(SUPER_END_STATE || (SUPER_END_STATE = {}));
/** superplayer这一层部分的业务data key */
var SUPER_DATA_KEY;
(function (SUPER_DATA_KEY) {
    SUPER_DATA_KEY["vodCGIUsed"] = "super:cgiUsed";
    /** 从getinfo拿到的广告信息，包括广告sessionid，hls中插时间段、植入广告信息等 */
    SUPER_DATA_KEY["getinfoAdInfo"] = "getinfoAdInfo";
    /** hls中插的时间段，由后台下发 */
    SUPER_DATA_KEY["hlsAdRanges"] = "hlsAdRanges";
})(SUPER_DATA_KEY || (SUPER_DATA_KEY = {}));
var LOCAL_STORAGE_KEY = {
    /** 缓存key */
    ENV_CACHE: '__thumbplayer_env_cache',
    RENDER_STATS_INFO: '__thumbplayer_render_stats_info',
    DEGRADE_CODEC_TIME: '__thumbplayer_degradecodec_time',
    DYNAMIC_CONFIG: '__thumbplayer_dynamic_config',
};
var ctrlbarPluginName = CtrlbarPluginName;
var contextMenuPluginName = UIContextMenuPluginName;

var SuperPlayerEnum = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get SuperStepKey () { return SuperStepKey; },
  get SUPER_END_STATE () { return SUPER_END_STATE; },
  get SUPER_DATA_KEY () { return SUPER_DATA_KEY; },
  LOCAL_STORAGE_KEY: LOCAL_STORAGE_KEY,
  ctrlbarPluginName: ctrlbarPluginName,
  contextMenuPluginName: contextMenuPluginName,
  adGlobalName: adGlobalName,
  adVersion: adVersion,
  adScriptMaxLoadTime: adScriptMaxLoadTime,
  getAdPluginPath: getAdPluginPath,
  skipAdDomainWhiteList: skipAdDomainWhiteList,
  isInDomainWhiteList: isInDomainWhiteList,
  PlayBtnStatus: PlayBtnStatus,
  CTRL_EVENTS: CTRL_EVENTS,
  CTRL_SIZE: CTRL_SIZE,
  TipsPluginName: TipsPluginName,
  ErrorPagePluginName: ErrorPagePluginName,
  PosterPluginName: PosterPluginName,
  CtrlbarPluginName: CtrlbarPluginName,
  InfoPanelPluginName: InfoPanelPluginName,
  WatermarkPluginName: WatermarkPluginName,
  UIContextMenuPluginName: UIContextMenuPluginName,
  PLUGINS_URL: PLUGINS_URL,
  ErrorPagePluginEvents: ErrorPagePluginEvents
});

/**
 * super-player这一层产生的事件类型枚举
 * SuperPlayer 扩展事件，在与各插件整合后的流程中产生并抛出
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
var SUPER_EVENTS;
(function (SUPER_EVENTS) {
    /** 降级编码播放，使用h265我们使用较低性能的wasm内核播放，如果性能跟不上，降级到原生的h264播放（硬解）*/
    SUPER_EVENTS["DEGRADE_CODEC"] = "degradeCodec";
    /** 试看开始 */
    SUPER_EVENTS["PREVIEW_START"] = "previewStart";
    /** 试看结束 */
    SUPER_EVENTS["PREVIEW_END"] = "previewEnd";
    /** get_video_mark_all请求返回 */
    SUPER_EVENTS["GET_VIDEO_MARK_ALL_OVER"] = "getVideoMarkAllOver";
    /** 进入hls中插广告 */
    SUPER_EVENTS["ENTER_HLS_AD"] = "enterHlsAd";
    /** 退出hls中插广告 */
    SUPER_EVENTS["EXIT_HLS_AD"] = "exitHlsAd";
})(SUPER_EVENTS || (SUPER_EVENTS = {}));

var SuperPlayerEvt = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get SUPER_EVENTS () { return SUPER_EVENTS; }
});

var coreExportKeys = [
    'PLAY_EVENT',
    'VIDEO_STATE',
    'KERNEL_NAME',
    'PLAY_MODE',
    'END_STATE',
    'EvtEmitter',
    'kernelEvtBus',
    'preloadEvtBus',
    'PAUSE_TYPE',
    'commonTool',
    'uaTool',
    'Logger',
    'cookieTool',
    'lsTool',
    'urlTool',
    'i18nConfig',
    'domTool',
    'netTool',
    'videoTool',
    'stringTool',
    'VIDEO_CODEC',
    'AUDIO_CODEC',
    'CONTAINER_FORMAT',
];
var h5ExportKeys = [
    'H5_PLAY_EVENT',
    'COMMON_DATA_KEY',
    'DATA_EVENTS',
    'DRM_TYPE',
    'DRM_VALUE',
    'H5_EXT_EVENT',
    'AdPluginName',
    'FullScreenMode',
    'Plugin',
];
var superPlayerExportKeys = [
    'CTRL_EVENTS',
    'SUPER_END_STATE',
    'SUPER_EVENTS',
    'ctrlbarPluginName',
    'contextMenuPluginName',
];
var tvkExportKeys = [
    'PLAY_CODEC',
    'TVK_EVENTS',
    'TVK_EVENT_DETAILS',
];
/**
 * 绑定导出对象到SuperPlayer类对象上。用于绑定core和h5模块中指定的导出到SuperPlayer对象上。例如将h5模块中的`H5_PLAY_EVENT`对象绑定到
 * SuperPlayer.H5_PLAY_EVENT，引用方引入时只需要展开SuperPlayer对象：
 * ```javascript
 * const { SuperPlayer } = window;
 * const { H5_PLAY_EVENT } = SuperPlayer;
 * ```
 *
 * 注意！一定要注意不能覆盖SuperPlayer对象上已定义的static属性，后续有增加导出需检查
 */
function bindExports(targetExports) {
    var exportKeys = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], coreExportKeys, true), h5ExportKeys, true), superPlayerExportKeys, true), tvkExportKeys, true);
    // 在targetExports上已经有的key，不能覆盖
    exportKeys = exportKeys.filter(function (key) { return typeof targetExports[key] === 'undefined'; });
    exportKeys.forEach(function (key) {
        [ThumbPlayerH5, ThumbPlayerCore, SuperPlayerEnum, SuperPlayerEvt, TVK].forEach(function (sourceExport) {
            if (sourceExport === null || sourceExport === void 0 ? void 0 : sourceExport[key]) {
                targetExports[key] = sourceExport[key];
            }
        });
    });
}

var _a$1;
/** 状态枚举 */
var STATE;
(function (STATE) {
    STATE[STATE["enabled"] = 0] = "enabled";
    STATE[STATE["disabled"] = 1] = "disabled";
})(STATE || (STATE = {}));
/** 广告类型枚举 */
var AdType = {
    MidRoll: 'ZC',
    HlsAd: 'PHLS',
    BeforePlay: AD_TYPE.PRE,
    BeforePlayCodeName: 'LD',
    AfterPlay: AD_TYPE.POST,
    AfterPlayCodeName: 'HT',
};
var AD_INFO_OP_TYPE;
(function (AD_INFO_OP_TYPE) {
    AD_INFO_OP_TYPE[AD_INFO_OP_TYPE["HLS_AD"] = 2] = "HLS_AD";
})(AD_INFO_OP_TYPE || (AD_INFO_OP_TYPE = {}));
var disabledCtrlBarComps = [
    // popups
    'playrate',
    'definition',
    'audiotrack',
    'language',
    // ctrlbar组件
    'PlayBtn',
    'NextBtn',
    'Progress',
    'CtrlShow',
    'PictureInPicture',
];
var disabledCtrlBarCompsWhenHlsAd = [
    'playrate',
    'definition',
    'audiotrack',
    'language',
];
/**
 * 各种广告类型禁用控件的映射表
 */
var disabledCtrlBarCompsMap = (_a$1 = {},
    _a$1[AdType.AfterPlay] = disabledCtrlBarComps,
    _a$1[AdType.BeforePlay] = disabledCtrlBarComps,
    _a$1[AdType.MidRoll] = disabledCtrlBarComps,
    _a$1[AdType.HlsAd] = disabledCtrlBarCompsWhenHlsAd,
    _a$1);

/**
 * 从getinfo解析hls中插的时间段
 */
function parseGetinfoHlsAdRanges(getinfoAdInfo) {
    var _a;
    var adTimeRanges = [];
    if (!(getinfoAdInfo === null || getinfoAdInfo === void 0 ? void 0 : getinfoAdInfo.adpinfo)) {
        return adTimeRanges;
    }
    // 和后台字段对齐
    // eslint-disable-next-line camelcase
    var adpinfoData = null;
    try {
        adpinfoData = JSON.parse(getinfoAdInfo.adpinfo);
    }
    catch (e) {
    }
    (_a = adpinfoData === null || adpinfoData === void 0 ? void 0 : adpinfoData.plugin_info) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
        if (+item.optype !== AD_INFO_OP_TYPE.HLS_AD) {
            return;
        }
        adTimeRanges.push({
            start: item.ad_offset_time,
            end: item.ad_offset_time + item.ad_dura,
        });
    });
    return adTimeRanges;
}

/**
 * 在super-player这一层的广告逻辑处理。
 */
var AdLogic = /** @class */ (function () {
    function AdLogic(player, corePlayer) {
        var _this = this;
        this.player = player;
        this.corePlayer = corePlayer;
        /** hls中插广告是否正在播放 */
        this.isHlsAdPlaying = false;
        /** hls中插点位信息 */
        this.adSlotInfo = [];
        this.logger = new Logger(this.player.config.instanceId, 'AdLogic');
        this.setEvts(true);
        this.player.pluginMsg.once("pluginsetup:".concat(AdPluginName), function () {
            var _a, _b;
            _this.adPlugin = getAdPlugin(_this.player.config.instanceId);
            if (uaTool.browser.safari) {
                try {
                    (_b = (_a = _this.adPlugin).setPhlsPlayType) === null || _b === void 0 ? void 0 : _b.call(_a);
                }
                catch (e) {
                    _this.logger.error('call adPlugin::setPhlsPlayType', e);
                }
            }
            _this.setAdPluginEvts(true);
        });
    }
    AdLogic.prototype.destroy = function () {
        if (getAdPlugin(this.player.config.instanceId)) {
            this.setAdPluginEvts(false);
        }
        this.setEvts(false);
        this.player = null;
        this.corePlayer = null;
    };
    AdLogic.prototype.setEvts = function (value) {
        var _a, _b;
        var _this = this;
        if (!this.evtMap) {
            this.evtMap = {
                player: (_a = {},
                    _a[H5_PLAY_EVENT.AD_PLAYING] = this.onAdPlaying.bind(this),
                    _a[H5_PLAY_EVENT.AD_END] = this.onAdEnd.bind(this),
                    _a[H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED] = this.onAdAutoplayBlocked.bind(this),
                    _a[H5_PLAY_EVENT.VIDEO_TIMEUPDATE] = this.onVideoTimeUpdate.bind(this),
                    _a[H5_PLAY_EVENT.AD_PAUSE] = this.onAdPaused.bind(this),
                    _a[H5_PLAY_EVENT.AD_RESUME] = this.onAdResume.bind(this),
                    _a[PLAY_EVENT.ENTER_INSERT_STREAM] = this.onEnterInsertStream.bind(this),
                    _a[PLAY_EVENT.EXIT_INSERT_STREAM] = this.onExitInsertStream.bind(this),
                    _a),
                adPlugin: {
                    enterCountdownCompleteEvt: this.onWillPlayMidRollAd.bind(this),
                    enterCountdownEvt: this.onEnterMidRollAdCountdown.bind(this),
                },
                msg: (_b = {},
                    _b[H5_EXT_EVENT.GETINFO_OVER] = this.onVideoReqInfoEnd.bind(this),
                    _b),
            };
        }
        var func = value ? this.player.on : this.player.off;
        Object.keys(this.evtMap.player).forEach(function (evtName) {
            func.apply(_this.player, [evtName, _this.evtMap.player[evtName]]);
        });
        var pluginMsgFunc = value ? this.player.on : this.player.off;
        Object.keys(this.evtMap.msg).forEach(function (evtName) {
            pluginMsgFunc.apply(_this.player.pluginMsg, [evtName, _this.evtMap.msg[evtName]]);
        });
    };
    AdLogic.prototype.setAdPluginEvts = function (value) {
        var _this = this;
        var adPlugin = getAdPlugin(this.player.config.instanceId);
        var adFuncs = value ? adPlugin.on : adPlugin.off;
        Object.keys(this.evtMap.adPlugin).forEach(function (evtName) {
            adFuncs.apply(adPlugin, [evtName, _this.evtMap.adPlugin[evtName]]);
        });
    };
    AdLogic.prototype.onAdPlaying = function (event) {
        var _a;
        var _this = this;
        var _b, _c, _d;
        var jobs = (_a = {},
            _a[AdType.BeforePlay] = function () { return _this.setCtrlBarState(STATE.disabled, AdType.BeforePlay); },
            _a[AdType.MidRoll] = function () { return _this.setCtrlBarState(STATE.disabled, AdType.MidRoll); },
            _a[AdType.AfterPlay] = function () { return _this.setCtrlBarState(STATE.disabled, AdType.AfterPlay); },
            _a);
        var adType = (_b = event.data) === null || _b === void 0 ? void 0 : _b.adType;
        (_c = jobs[adType]) === null || _c === void 0 ? void 0 : _c.apply(this);
        (_d = this.player.loadingPlugin) === null || _d === void 0 ? void 0 : _d.hide();
    };
    AdLogic.prototype.onAdPaused = function () {
        // 因为任何原因导致的广告暂停，都需要解除控制栏的限制，避免卡死。
        var ctrlbarPlugin = this.player.ctrlbarPlugin;
        if (!ctrlbarPlugin || uaTool.mobile)
            return;
        ctrlbarPlugin.show(true);
        ctrlbarPlugin.setCompDisable('PlayBtn', false);
    };
    AdLogic.prototype.onAdResume = function (_a) {
        var data = _a.data;
        // todo 标准化事件
        var adtype = data.adtype;
        // 这里用LD，HT等广告插件实际使用的类型名，因为事件是从广告插件直接监听的，尚未标准化
        var targetAdtype = [AdType.AfterPlayCodeName, AdType.MidRoll, AdType.BeforePlayCodeName];
        var ctrlbarPlugin = this.player.ctrlbarPlugin;
        if (!ctrlbarPlugin || uaTool.mobile)
            return;
        if (targetAdtype.includes(adtype)) {
            ctrlbarPlugin.setCompDisable('PlayBtn');
        }
    };
    AdLogic.prototype.onAdEnd = function (event) {
        var _a;
        var _this = this;
        var _b, _c;
        var jobs = (_a = {},
            _a[AdType.BeforePlay] = function () { return _this.setCtrlBarState(STATE.enabled, AdType.BeforePlay); },
            _a[AdType.MidRoll] = function () {
                _this.setCtrlBarState(STATE.enabled, AdType.MidRoll);
                _this.player.play();
            },
            _a[AdType.AfterPlay] = function () { return _this.setCtrlBarState(STATE.enabled, AdType.AfterPlay); },
            _a);
        var adType = (_b = event.data) === null || _b === void 0 ? void 0 : _b.adType;
        (_c = jobs[adType]) === null || _c === void 0 ? void 0 : _c.apply(this);
    };
    AdLogic.prototype.onAdAutoplayBlocked = function (_a) {
        var _b;
        var data = _a.data;
        if (data.adType !== AdType.BeforePlay) {
            // 只有前贴广告需要处理自动播放被阻止的逻辑
            return;
        }
        // 广告被自动播放拦截的时候，处于等待状态，需要隐藏掉loading动画
        (_b = this.player.loadingPlugin) === null || _b === void 0 ? void 0 : _b.hide();
        // 广告自动播放被拦截时展示控制栏，解除播放按钮禁用
        var ctrlbarPlugin = this.player.ctrlbarPlugin;
        if (!ctrlbarPlugin)
            return;
        ctrlbarPlugin.show(true);
        ctrlbarPlugin.setCompDisable('PlayBtn', false);
        ctrlbarPlugin.setCompDisable(['PictureInPicture', 'playrate'], true);
    };
    AdLogic.prototype.onWillPlayMidRollAd = function () {
        this.player.pause();
        try {
            getAdPlugin(this.player.config.instanceId).playAd({ adType: AdType.MidRoll });
        }
        catch (e) {
            this.logger.error('playMidRollAd, call adPlugin::playAd', e);
        }
    };
    AdLogic.prototype.onEnterMidRollAdCountdown = function () {
        this.setCtrlBarState(STATE.disabled, AdType.MidRoll);
    };
    /**
     * 禁用/解禁一些ui操作
     */
    AdLogic.prototype.setCtrlBarState = function (disabled, adType) {
        var ctrlbarPlugin = this.player.plugins[CtrlbarPluginName];
        if (!ctrlbarPlugin) {
            return;
        }
        var ctrlBarCompDisableArr = disabledCtrlBarCompsMap[adType];
        ctrlbarPlugin.setCompDisable(ctrlBarCompDisableArr, !!disabled);
        switch (adType) {
            case AdType.HlsAd:
                // HlsAd标版时不禁用控制组件
                break;
            default:
                ctrlbarPlugin.setHotKeysDisable(!!disabled);
                break;
        }
    };
    AdLogic.prototype.onVideoReqInfoEnd = function (evt) {
        var _a, _b, _c, _d;
        var data = evt.data;
        var vitem = ((data === null || data === void 0 ? void 0 : data.parseData) || {}).vitem;
        if (data === null || data === void 0 ? void 0 : data.error)
            return;
        if (!(vitem === null || vitem === void 0 ? void 0 : vitem.ad)) {
            // 每次请求完，如果没有广告，则需要重置
            this.player.setCommonKv(SUPER_DATA_KEY.hlsAdRanges, null);
            this.player.setCommonKv(SUPER_DATA_KEY.getinfoAdInfo, null);
            return;
        }
        var getinfoHlsAdRanges = parseGetinfoHlsAdRanges(vitem.ad);
        this.player.setCommonKv(SUPER_DATA_KEY.hlsAdRanges, getinfoHlsAdRanges);
        this.player.setCommonKv(SUPER_DATA_KEY.getinfoAdInfo, vitem.ad);
        this.adSlotInfo = commonTool.mergeTimeRanges((_d = (_c = (_b = (_a = data.parseData) === null || _a === void 0 ? void 0 : _a.supplementaryInfo) === null || _b === void 0 ? void 0 : _b.contentInfo) === null || _c === void 0 ? void 0 : _c.ad) !== null && _d !== void 0 ? _d : []);
        this.logger.log("hlsAdRanges from srv is ".concat(getinfoHlsAdRanges.map(function (r) { return "[".concat(r.start, ", ").concat(r.end, "]"); })));
    };
    AdLogic.prototype.onVideoTimeUpdate = function (evt) {
        var data = evt.data;
        var playtime = (data || {}).playtime;
        if (
        // safari下使用兼容模式，不使用timeupdate事件
        uaTool.browser.safari
            // 非法播放时间
            || playtime <= 0) {
            return;
        }
        this.checkWhetherEnterOrExitHlsAd(playtime);
    };
    /**
     * 检查是否进入或者退出hls中插广告区间
     * @param playtime 当前播放时间
     * @returns
     */
    AdLogic.prototype.checkWhetherEnterOrExitHlsAd = function (playtime) {
        var hlsAdRanges = this.player.getCommonKv(SUPER_DATA_KEY.hlsAdRanges);
        if (!hlsAdRanges || hlsAdRanges.length <= 0) {
            // 没有hls中插区间, 避免新清晰度因异常没有中插信息导致的变量无法重置
            this.exitHlsAd();
            return;
        }
        var hlsAdRange = hlsAdRanges.find(function (range) { return range.start <= playtime && playtime <= range.end; });
        if (!this.isHlsAdPlaying && hlsAdRange) {
            this.enterHlsAd(playtime, hlsAdRange);
        }
        else if (this.isHlsAdPlaying && !hlsAdRange) {
            this.exitHlsAd();
        }
    };
    /**
     * 进入hls中插广告区间
     * @param playtime 当前播放时间
     * @param hlsAdRange 进入的区间范围
     */
    AdLogic.prototype.enterHlsAd = function (playtime, hlsAdRange) {
        if (this.isHlsAdPlaying)
            return;
        this.logger.log("enter hlsAd, playtime=".concat(playtime, ", range=[").concat(hlsAdRange.start, ", ").concat(hlsAdRange.end, "]"));
        this.isHlsAdPlaying = true;
        this.player.emit(SUPER_EVENTS.ENTER_HLS_AD, { hlsAdRange: hlsAdRange });
    };
    AdLogic.prototype.exitHlsAd = function () {
        if (!this.isHlsAdPlaying)
            return;
        this.logger.log('exit hlsAd....');
        this.isHlsAdPlaying = false;
        this.player.emit(SUPER_EVENTS.EXIT_HLS_AD);
    };
    AdLogic.prototype.onEnterInsertStream = function (evt) {
        var _a, _b, _c, _d;
        var index = ((_a = evt === null || evt === void 0 ? void 0 : evt.data) !== null && _a !== void 0 ? _a : {}).index;
        this.logger.log('enter insert stream', this.adSlotInfo[index]);
        var slot = (_b = this.adSlotInfo) === null || _b === void 0 ? void 0 : _b[index];
        if (slot) {
            this.setCtrlBarState(STATE.disabled, AdType.HlsAd);
            (_d = (_c = this.adPlugin) === null || _c === void 0 ? void 0 : _c.startSoloPlayPhls) === null || _d === void 0 ? void 0 : _d.call(_c, slot.start);
            this.player.emit(H5_PLAY_EVENT.AD_PLAYING, { adType: AdType.HlsAd });
        }
    };
    AdLogic.prototype.onExitInsertStream = function (evt) {
        var _a, _b, _c;
        var index = ((_a = evt === null || evt === void 0 ? void 0 : evt.data) !== null && _a !== void 0 ? _a : {}).index;
        this.logger.log('exit insert stream', this.adSlotInfo[index]);
        this.setCtrlBarState(STATE.enabled, AdType.HlsAd);
        (_c = (_b = this.adPlugin) === null || _b === void 0 ? void 0 : _b.endSoloPlayPhls) === null || _c === void 0 ? void 0 : _c.call(_b);
        this.player.emit(H5_PLAY_EVENT.AD_END, { code: ErrorCode.SUC, adType: AdType.HlsAd });
    };
    return AdLogic;
}());

var COOKIE_AVAILABLE_HOSTS = ['v.qq.com', 'test.v.qq.com'];
/**
 * 在v站写入cookie
*/
function setVSiteCookie(key, value) {
    cookieTool.set(key, value, ".".concat(location.host), '/', 999, true);
}
var CookieLogic = /** @class */ (function () {
    function CookieLogic(player) {
        var _this = this;
        this.player = player;
        this.onVideoPlaying = function (_a) {
            var data = _a.data;
            return __awaiter(_this, void 0, void 0, function () {
                var capConfig, capConfigStr;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!data.isFirst) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, getAllCapabilityConfig()];
                        case 1:
                            capConfig = _b.sent();
                            capConfigStr = convertCapabilityConfig2String(capConfig);
                            setVSiteCookie(PLAYER_COOKIE.SPTS, capConfigStr);
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.onAdEnd = function (_a) {
            var data = _a.data;
            if (data.adType === AD_TYPE.PRE && data.isAllAdEnd && data.rfid) {
                setVSiteCookie(PLAYER_COOKIE.AD_RFID, data.rfid);
            }
        };
        this.setPlayerListener(true);
    }
    CookieLogic.prototype.destroy = function () {
        this.setPlayerListener(false);
        this.player = null;
    };
    CookieLogic.prototype.setDefn = function (defn) {
        setVSiteCookie(PLAYER_COOKIE.DEFN_VOD, defn);
    };
    CookieLogic.prototype.setPlayerListener = function (isEnable) {
        var evtBinder = isEnable
            ? this.player.on.bind(this.player)
            : this.player.off.bind(this.player);
        evtBinder(H5_PLAY_EVENT.VIDEO_PLAYING, this.onVideoPlaying);
        evtBinder(H5_PLAY_EVENT.AD_END, this.onAdEnd);
    };
    return CookieLogic;
}());

/**
 * 展示封面图时机：
 * 1. 广告被阻止展示封面图
 * 2. 如果有后贴广告播放，后贴广告结束后腾讯视频点播展示封面图（理论上直播没有后贴）
 * 3. 广告播放期间被 player.stop 打断，展示封面图
 */
var PosterLogic = /** @class */ (function () {
    function PosterLogic(player) {
        this.player = player;
        /** session内是否有后贴广告播放 */
        this.hasPostAdInPlaySession = false;
        this.setEvts(true);
        this.showDefaultPoster();
    }
    PosterLogic.prototype.destroy = function () {
        this.setEvts(false);
        this.player = null;
    };
    /**
     * 根据superplayer配置中的videoid显示默认封面图
     */
    PosterLogic.prototype.showDefaultPoster = function () {
        var _this = this;
        var _a = this.player.config, videoId = _a.videoId, type = _a.type, videoInitConfig = _a.videoInitConfig;
        var lastVideoId = videoId;
        if (videoInitConfig) {
            if (typeof videoInitConfig === 'string') {
                lastVideoId = videoInitConfig;
            }
            else {
                var vid = videoInitConfig.vid;
                if (vid) {
                    lastVideoId = vid;
                }
            }
        }
        var showVodDefaultPoster = function () {
            if (type === PLAY_MODE.VOD && lastVideoId) {
                // superplayer的配置传videoid默认显示videoid对应的封面图
                _this.showPoster(lastVideoId);
            }
        };
        showVodDefaultPoster();
    };
    /**
     * 显示封面图。腾讯视频点播用vid展示，腾讯视频直播用默认封面图
     */
    PosterLogic.prototype.showPoster = function (vodVid) {
        var _a = this.player.config, poster = _a.poster, disablePoster = _a.disablePoster, type = _a.type;
        var posterPlugin = this.player.getPlugin(PosterPluginName);
        if (disablePoster || !posterPlugin) {
            return;
        }
        if (poster === null || poster === void 0 ? void 0 : poster.src) {
            // 如果有配置直接传入的poster地址，直接展示外部传入
            posterPlugin.show(poster.src);
            return;
        }
        if (type === PLAY_MODE.VOD) {
            if (vodVid && typeof vodVid === 'string') {
                posterPlugin.showByVid(__assign(__assign({}, poster), { vid: vodVid }));
            }
            return;
        }
        // 直播显示默认封面图
        posterPlugin.show('https://puui.qpic.cn/vupload/0/20171225_1514277750947.jpeg/0');
    };
    PosterLogic.prototype.setEvts = function (value) {
        var _a;
        var _this = this;
        if (!this.evtMap) {
            this.evtMap = (_a = {},
                _a[H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED] = this.onAdAutoplayBlocked.bind(this),
                _a[H5_PLAY_EVENT.AD_PLAYING] = this.onAdPlaying.bind(this),
                _a[H5_PLAY_EVENT.PLAY_SESSION_END] = this.onPlaySessionEnd.bind(this),
                _a);
        }
        var func = value ? this.player.on : this.player.off;
        Object.keys(this.evtMap).forEach(function (evtName) {
            func.apply(_this.player, [evtName, _this.evtMap[evtName]]);
        });
    };
    PosterLogic.prototype.onAdAutoplayBlocked = function (_a) {
        var data = _a.data;
        if (this.player.config.autoPlayPolicy === AUTO_PLAY_POLICY.IN_MUTED) {
            // 如果是inMuted起播，不但会走到这个回调函数，还会继续静音播放。如果显示poster会概率性导致poster在广告起播前闪一下马上被隐藏
            return;
        }
        if (data.adType !== AD_TYPE.PRE) {
            // 只有前贴广告需要在被阻止时，显示封面图
            return;
        }
        this.showPoster(this.player.vid);
    };
    PosterLogic.prototype.onAdPlaying = function (_a) {
        var data = _a.data;
        if (data.adType === AD_TYPE.POST) {
            this.hasPostAdInPlaySession = true;
        }
    };
    PosterLogic.prototype.waitSessionStart = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var callback = function () { return resolve(true); };
            _this.player.once(H5_PLAY_EVENT.PLAY_SESSION_START, callback);
            setTimeout(function () {
                var _a;
                (_a = _this.player) === null || _a === void 0 ? void 0 : _a.off(H5_PLAY_EVENT.PLAY_SESSION_START, callback);
                resolve(false);
            }, SESSION_DURATION);
        });
    };
    PosterLogic.prototype.onPlaySessionEnd = function (_a) {
        var data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            var curFlowNodeName, endState, isSessionStart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        curFlowNodeName = data.curFlowNodeName, endState = data.endState;
                        // 1. 如果播到了后贴广告，则 SESSION_END 时展示封面图
                        if (this.hasPostAdInPlaySession) {
                            this.hasPostAdInPlaySession = false;
                            this.showPoster(this.player.vid);
                            return [2 /*return*/];
                        }
                        if (!(AD_FLOW_NODE_NAME_REG.test(curFlowNodeName) && endState !== END_STATE.NORMAL)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.waitSessionStart()];
                    case 1:
                        isSessionStart = _b.sent();
                        !isSessionStart && this.showPoster(this.player.vid);
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return PosterLogic;
}());
/**
 * 正则判断节点名是否为广告节点
 */
var AD_FLOW_NODE_NAME_REG = /AdFlowNode/i;
/** SessionStart 与 SessionEnd 时间间隔 */
var SESSION_DURATION = 400;

/** URL注入参数名 */
var UrlParamKey;
(function (UrlParamKey) {
    UrlParamKey["debugSuper"] = "__debugSuper";
    UrlParamKey["logLevel"] = "__logLevel";
    UrlParamKey["downloadKit"] = "__downloadKit";
    UrlParamKey["forceCodec"] = "__forceCodec";
    /** 是否走测试环境请求接口 */
    UrlParamKey["testSrv"] = "__testSrv";
})(UrlParamKey || (UrlParamKey = {}));
/**
 * 检查某些接口的参数合法性
 */
function checkParams(mode, funcName, config) {
    if (!funcName || !config) {
        return;
    }
    var SPI18n = i18nConfig.superPlayer;
    var illegalConds = [
        {
            // 传入的参数是空的
            checker: function () { return typeof config !== 'string' // config参数可能是一个vid字符串
                && !config.vid
                && !config.cnlid
                && !config.url; },
            msg: t(SPI18n.ERROR_EMPTY_PARAM),
        },
        {
            // 直播不能调用load接口
            checker: function () { return mode === PLAY_MODE$1.LIVE && funcName === 'load'; },
            msg: t(SPI18n.ERROR_LOAD_PARAM_NOT_SUPPORT),
        }, {
            // 直播play接口不能传入vid
            checker: function () { return mode === PLAY_MODE$1.LIVE && funcName === 'play' && config.vid; },
            msg: t(SPI18n.ERROR_VID_NOT_SUPPORT),
        }, {
            // 点播不能传cnlid
            checker: function () { return mode === PLAY_MODE$1.VOD && config.cnlid; },
            msg: t(SPI18n.ERROR_CNLID_NOT_SUPPORT),
        }, {
            // 传入的vid不合法
            checker: function () {
                var vid = typeof config === 'string' ? config : config.vid; // config参数可能是一个vid字符串
                return vid === '' || (vid && !/^\w{11}$/.test(vid));
            },
            msg: t(SPI18n.ERROR_VID_INVALID),
        },
    ];
    for (var i = 0, len = illegalConds.length; i < len; i++) {
        if (illegalConds[i].checker()) {
            return illegalConds[i].msg;
        }
    }
    return null;
}
/**
 * 将清晰度字符串格式化，例如将字符串”标清;(270P)“转换为数组['标清', '270P']
 */
function formatDefnName(cname, isLive) {
    if (isLive === void 0) { isLive = false; }
    if (isLive)
        return formatLiveDefnName(cname);
    var reg = /(.*);\((.*)\)/;
    var arr = cname === null || cname === void 0 ? void 0 : cname.match(reg);
    if ((arr === null || arr === void 0 ? void 0 : arr.length) >= 3) {
        return [arr[1], arr[2]];
    }
    // 审核部分cgi返回清晰度名称仅包含清晰度（270p，1080p）这里需要做一下兼容
    return [cname !== null && cname !== void 0 ? cname : '', ''];
}
/** 蓝光 1080P -> ['蓝光', '1080P'] */
function formatLiveDefnName(cname) {
    var _a = cname.split(' '), name = _a[0], number = _a[1];
    return [name, number];
}
/**
 * 判断当前环境是否为官方播放
 */
function getIsOfficialScenes() {
    // (.com)是为了避免被 tde 修改
    var conditions = [
        /^http(s?):\/\/v\.qq(\.com)\/x\/(cover|page)\//.test(location.href),
        uaTool.browser.qqlive,
    ];
    return conditions.some(function (i) { return i; });
}
/**
 * 判断当前环境是否是qq域，放开部分策略
 */
function isOfficialDomain() {
    return /^http(s?):\/\/(.*)\.(qq|woa|oa)\.com/.test(location.href);
}
/**
 * 拼接跳转v站链接。
 */
function getTxVideoPageURLByVid(vid, exStr, start) {
    if (!vid) {
        return '';
    }
    if (exStr !== '0') {
        exStr = "_".concat(exStr);
    }
    else {
        exStr = '';
    }
    var homepage = 'https://v.qq.com/page';
    var part1 = vid.substr(0, 1);
    var part2 = vid.substr(vid.length - 2, 1);
    var part3 = vid.substr(vid.length - 1, 1);
    var url = "".concat(homepage, "/").concat(part1, "/").concat(part2, "/").concat(part3, "/").concat(vid).concat(exStr, ".html");
    if (start) {
        url += "?start=".concat(start);
    }
    return url;
}
/**
 * 获取环境变量。
 */
function getEnvVals() {
    var CHANNEL = 'npm';
    try {
        CHANNEL = "npm";
    }
    catch (_a) { }
    var VERSION = '';
    try {
        VERSION = "1.30.10";
    }
    catch (_b) { }
    var BUILD_TIME = '';
    try {
        BUILD_TIME = "1708400693978";
    }
    catch (_c) { }
    var LOCAL_DEV = false;
    try {
        // @ts-ignore
        LOCAL_DEV = process.env.__LOCAL_DEV__ === '1';
    }
    catch (_d) { }
    var IS_BETA = false;
    try {
        // @ts-ignore
        IS_BETA = "0" === '1';
    }
    catch (_e) { }
    return {
        CHANNEL: CHANNEL,
        VERSION: IS_BETA ? "".concat(VERSION, "-beta") : VERSION,
        BUILD_TIME: BUILD_TIME,
        /** 是否本地调试 */
        LOCAL_DEV: LOCAL_DEV,
    };
}
/** 从url参数读取配置，是否为调试模式 */
function getDebugModeFromUrl() {
    return urlTool.getUrlParamByKey(location.href, UrlParamKey.debugSuper) === '1';
}
/** 从url参数读取配置，打开不同等级的日志 */
function getLogLevelFromUrl() {
    var logLevel = +urlTool.getUrlParamByKey(location.href, UrlParamKey.logLevel);
    if (isNaN(logLevel)) {
        return PLAYER_LOG_LEVEL.NONE;
    }
    return logLevel;
}
function getForceCodecFromUrl() {
    return urlTool.getUrlParamByKey(location.href, UrlParamKey.forceCodec);
}
function getTestProxyHttpPath() {
    return urlTool.getUrlParamByKey(location.href, UrlParamKey.testSrv) === '1' ? 'https://testvd.l.qq.com/proxyhttp' : void 0;
}

/**
 * 试看逻辑
 * 1. 移动端试看，只允许播后台下发的试看配置时长，播到设置的时间后 stop
 * 2. PC 端试看，只允许播后台下发的试看配置时长，播到设置的时间后 pause
 */
var PreviewLogic = /** @class */ (function () {
    function PreviewLogic(player) {
        var _this = this;
        this.player = player;
        this.previewDuration = NO_PREVIEW_FLAG;
        /** 中间试看的起点 */
        this.previewStartPosition = 0;
        /** 标志是否试看结束，用于区分 Web 下试看结束 pause 事件，防止重复抛出试看结束 */
        this.isPreviewEnd = false;
        /** 试看结束 pause 时，会禁用快捷操作，这里两个变量保存禁用前状态方便恢复 */
        this.lastHotKeysDisabled = false;
        this.lastCtrlShowDisabled = false;
        /** 直播开始试看的时间戳，取+new Date() */
        this.previewStartTimeOnLive = 0;
        /** 剩余的可试看次数 */
        this.previewRemainCount = 0;
        this.onVideoSessionStart = function () {
            if (!_this.ctrlPlugin || !_this.isVod)
                return;
            _this.ctrlPlugin.duration = undefined;
        };
        /**
         * 获取 GET_INFO 返回的试看配置，在 PC 端上，设置控制栏假显
         */
        this.onVideoReqInfoEnd = function (_a) {
            var _b = _a.data, code = _b.code, data = _b.data;
            if (code !== ErrorCode.SUC)
                return;
            var _c = (data === null || data === void 0 ? void 0 : data.parseData) || {}, previewOld = _c.preview, duration = _c.duration, previewRemainCount = _c.previewRemainCount, supplementaryInfo = _c.supplementaryInfo;
            var contentInfo = (supplementaryInfo !== null && supplementaryInfo !== void 0 ? supplementaryInfo : {}).contentInfo;
            var _d = contentInfo !== null && contentInfo !== void 0 ? contentInfo : {}, preview = _d.preview, _e = _d.previewStartPosition, previewStartPosition = _e === void 0 ? 0 : _e;
            var previewUsed = preview !== null && preview !== void 0 ? preview : previewOld;
            // 无需试看或者根本无法试看
            if (Number.isNaN(previewUsed) || previewUsed <= 0)
                return;
            _this.previewDuration = previewUsed;
            _this.previewRemainCount = previewRemainCount;
            _this.previewStartPosition = previewStartPosition;
            if (_this.isVod) {
                _this.showTips();
                // 如果启用了控制栏插件，则设置控制栏假显
                if (_this.ctrlPlugin) {
                    // 移动端则不设置假显，因为移动端如果被劫持以后一定显示的是流时间。而移动端劫持比较常见
                    _this.player.ctrlbarPlugin.duration = uaTool.mobile ? _this.previewDuration : duration;
                    if (!uaTool.mobile) {
                        _this.setCtrlMaxPercent((previewUsed + previewStartPosition) / duration);
                    }
                }
            }
            else {
                // 直播试看开始
                _this.showTips();
            }
            _this.player.emit(SUPER_EVENTS.PREVIEW_START, { previewDuration: previewUsed, previewStartPosition: previewStartPosition });
        };
        /**
         * 如果试看结束后，因为如切清晰度事件导致起播
         * 则需要清理掉 isPreviewEnd 标志让 PREVIEW_END 事件重新抛出
         */
        this.onVideoPlaying = function (_a) {
            var data = _a.data;
            if (!!data.isFirst) {
                // 直播试看，在开播以后才开始计算试看时长
                _this.previewStartTimeOnLive = +new Date();
            }
            if (_this.isPreviewEnd) {
                _this.isPreviewEnd = false;
                if (!_this.ctrlPlugin)
                    return;
                _this.restoreCtrlBarAction();
            }
        };
        /** TIME_UPDATE 事件回调，检查试看时长并在时长结束时终止 */
        this.onVideoTimeUpdate = function (_a) {
            var playtime = _a.data.playtime;
            var isPreviewOver = false;
            if (_this.isVod) {
                isPreviewOver = _this.checkPreviewOverOnVodMode(playtime);
            }
            else {
                isPreviewOver = _this.checkPreviewOverOnLiveMode();
            }
            if (isPreviewOver) {
                _this.isPreviewEnd = true;
                _this.player.emit(SUPER_EVENTS.PREVIEW_END, {
                    previewDuration: _this.previewDuration,
                    previewRemainCount: _this.previewRemainCount,
                });
            }
        };
        /** 每次播到结束，清理掉设置的试看时间，防止播完一个 vid，再去播 URL 时仍然保有试看 */
        this.onPlaySessionEnd = function () {
            var _a;
            if (_this.previewDuration !== NO_PREVIEW_FLAG) {
                (_a = _this.player.tipsPlugin) === null || _a === void 0 ? void 0 : _a.hide();
            }
            _this.previewDuration = NO_PREVIEW_FLAG;
            _this.previewStartTimeOnLive = 0;
            _this.previewStartPosition = 0;
            if (!_this.ctrlPlugin)
                return;
            _this.setCtrlMaxPercent(1);
            _this.restoreCtrlBarAction();
        };
        /**
         * 暂停时，设置控制栏播放按钮状态
         * 如果在 TimeUpdate 设置，则会被控制栏监听 pause 事件覆盖掉不生效
         */
        this.onVideoPause = function () {
            if (!_this.isPreviewEnd)
                return;
            _this.setCtrlPlayBtnStatus(PlayBtnStatus.REPLAY);
        };
        this.setPreviewListener(true);
    }
    PreviewLogic.prototype.destroy = function () {
        this.setPreviewListener(false);
        this.player = null;
    };
    /** 设置试看监听器，监听 TIME_UPDATE 事件*/
    PreviewLogic.prototype.setPreviewListener = function (isEnable) {
        var evtBinder = isEnable
            ? this.player.on.bind(this.player)
            : this.player.off.bind(this.player);
        evtBinder(H5_PLAY_EVENT.PLAY_SESSION_START, this.onVideoSessionStart);
        evtBinder(H5_PLAY_EVENT.VIDEO_REQ_INFO_END, this.onVideoReqInfoEnd);
        evtBinder(H5_PLAY_EVENT.VIDEO_PLAYING, this.onVideoPlaying);
        evtBinder(H5_PLAY_EVENT.VIDEO_TIMEUPDATE, this.onVideoTimeUpdate);
        evtBinder(H5_PLAY_EVENT.VIDEO_PAUSE, this.onVideoPause);
        evtBinder(H5_PLAY_EVENT.PLAY_SESSION_END, this.onPlaySessionEnd);
    };
    /**
    * 检查点播试看是否结束
    * @param playtime 播放时间点
    * @returns 是否结束
    */
    PreviewLogic.prototype.checkPreviewOverOnVodMode = function (playtime) {
        var _this = this;
        if (this.previewDuration === NO_PREVIEW_FLAG
            || (playtime < (this.previewStartPosition + this.previewDuration) // 试看结束位置
                && playtime >= this.previewStartPosition) // 试看开始位置
            || this.isPreviewEnd)
            return false;
        if (uaTool.mobile) {
            setTimeout(function () {
                _this.player.corePlayer.stop(SUPER_END_STATE.PREVIEW);
            });
        }
        else {
            this.player.pause();
            this.disableCtrlAction();
        }
        return true;
    };
    /**
     * 检查直播试看是否结束。直播的试看用倒计时的方式，跟点播不同。
     */
    PreviewLogic.prototype.checkPreviewOverOnLiveMode = function () {
        var _this = this;
        if (this.previewDuration === NO_PREVIEW_FLAG
            || this.previewStartTimeOnLive <= 0
            || this.isPreviewEnd
            || +new Date() - this.previewStartTimeOnLive <= this.previewDuration * 1000) {
            return false;
        }
        setTimeout(function () {
            _this.player.corePlayer.stop(SUPER_END_STATE.PREVIEW);
        });
        return true;
    };
    /** 设置控制栏播放按钮状态 */
    PreviewLogic.prototype.setCtrlPlayBtnStatus = function (status) {
        var _a, _b;
        var PlayBtn = (_b = (_a = this.ctrlPlugin) === null || _a === void 0 ? void 0 : _a.instances) === null || _b === void 0 ? void 0 : _b.PlayBtn;
        if (!PlayBtn)
            return;
        PlayBtn.el.dataset.status = status;
    };
    /** 设置控制栏进度条最大进度值，范围 0～1，清空则设置为 1 */
    PreviewLogic.prototype.setCtrlMaxPercent = function (percentage) {
        var _a, _b;
        if (percentage === void 0) { percentage = 1; }
        var Progress = (_b = (_a = this.ctrlPlugin) === null || _a === void 0 ? void 0 : _a.instances) === null || _b === void 0 ? void 0 : _b.Progress;
        if (!Progress)
            return;
        Progress.maxPercent = percentage;
    };
    /** 当 Web 端试看结束导致暂停后，禁用掉控制栏的一些操作 */
    PreviewLogic.prototype.disableCtrlAction = function () {
        if (!this.ctrlPlugin)
            return;
        // 先存储，方便恢复
        this.lastHotKeysDisabled = this.ctrlPlugin.getIsHotKeysDisabled();
        this.lastCtrlShowDisabled = this.ctrlShow.shadowClickDisabled;
        this.ctrlShow.shadowClickDisabled = true;
        this.ctrlPlugin.setHotKeysDisable(true);
    };
    /** 恢复控制栏快捷操作 */
    PreviewLogic.prototype.restoreCtrlBarAction = function () {
        if (!this.ctrlPlugin)
            return;
        this.ctrlPlugin.setHotKeysDisable(this.lastHotKeysDisabled);
        this.ctrlShow.shadowClickDisabled = this.lastCtrlShowDisabled;
    };
    /** 展示左下角试看 xx 分钟 Tips */
    PreviewLogic.prototype.showTips = function () {
        var _a;
        var isOfficialScenes = getIsOfficialScenes();
        if (!isOfficialScenes) {
            var timeStr = commonTool.formatPlayTime(this.previewDuration);
            var pageLink = getTxVideoPageURLByVid(this.player.vid, '0');
            (_a = this.player.tipsPlugin) === null || _a === void 0 ? void 0 : _a.show({
                text: t(i18nConfig.superPlayer.PREVIEW_TIPS, timeStr, pageLink),
                time: -1,
            });
        }
    };
    Object.defineProperty(PreviewLogic.prototype, "isVod", {
        get: function () {
            return this.player.config.type === PLAY_MODE.VOD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreviewLogic.prototype, "ctrlShow", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.ctrlPlugin) === null || _a === void 0 ? void 0 : _a.instances) === null || _b === void 0 ? void 0 : _b.CtrlShow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreviewLogic.prototype, "ctrlPlugin", {
        get: function () {
            return this.player.plugins[CtrlbarPluginName];
        },
        enumerable: false,
        configurable: true
    });
    return PreviewLogic;
}());
/* 没有试看 */
var NO_PREVIEW_FLAG = 0;

/**
 * 提前加载广告插件（默认是创建播放器的时候加载的）
 */
function preloadAdPlugin() {
    var _a;
    var adVersion = (_a = window.SuperPlayerConfig) === null || _a === void 0 ? void 0 : _a.adVersion;
    if (!adVersion) {
        // 只有v站，会给这个配置。没给就不提前加载。
        return;
    }
    return domTool.loadScript(getAdPluginPath(adVersion), undefined, adScriptMaxLoadTime, { crossOrigin: 'anonymous' });
}

var SuperBaseCheck = /** @class */ (function (_super) {
    __extends(SuperBaseCheck, _super);
    function SuperBaseCheck(player) {
        var _this = _super.call(this, player) || this;
        _this.isRetryedInSession = false;
        _this.superPlayer = player;
        return _this;
    }
    SuperBaseCheck.prototype.onSessionStart = function () {
        this.isRetryedInSession = false;
    };
    /**
     * @param videoInfo 播放信息
     * @param degradeOpts 降级配置，如果为空则不降级
     * @returns
     */
    SuperBaseCheck.prototype.getRetryConfig = function (videoInfo, degradeOpts) {
        var result = _super.prototype.getRetryConfig.call(this, videoInfo);
        var _a = degradeOpts || {}, _b = _a.degradeCodecExpireTime, degradeCodecExpireTime = _b === void 0 ? 0 : _b, _c = _a.degradeReason, degradeReason = _c === void 0 ? DEGRADE_CODEC_REASON.UNKNOWN : _c;
        if (result && degradeReason !== DEGRADE_CODEC_REASON.UNKNOWN && this.canDegradeCodecDefn()) {
            // 不播放hevc啦
            result.updatePlayParam.videoReqInfoParam.hevclv = HEVC_LV_VALUE.NOT_SPT;
            result.updatePlayParam.videoReqInfoParam.spav1 = 0;
        }
        else {
            // 条件不通过，也不会降级
            degradeCodecExpireTime = 0;
            degradeReason = DEGRADE_CODEC_REASON.UNKNOWN;
        }
        return __assign(__assign({}, result), { degradeCodecExpireTime: degradeCodecExpireTime, degradeReason: degradeReason });
    };
    /**
     * 是否可以降级播放。因为腾讯视频4k、hdr等高品质清晰度都为hevc编码，h.264没有对应清晰度，因此不能降级播放。
     * @param defn 当前播放的清晰度名称
     * @returns 是否可降级播放
     */
    SuperBaseCheck.prototype.canDegradeCodecDefn = function (defn) {
        if (!defn) {
            defn = this.superPlayer.getCommonKv(COMMON_DATA_KEY.currentDefn);
        }
        return [FORMAT.SD, FORMAT.HD, FORMAT.SHD, FORMAT.FHD].indexOf(defn) !== -1;
    };
    return SuperBaseCheck;
}(BaseCheck));

/**
 * 检查渲染性能，当渲染性能低于配置的阀值时，需要重试播放。
 */
var CheckFrameDropRate = /** @class */ (function (_super) {
    __extends(CheckFrameDropRate, _super);
    function CheckFrameDropRate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckFrameDropRate;
        _this.checkEvt = PLAY_EVENT.TIME_UPDATE;
        _this.intervalFrameDroppedArr = [];
        return _this;
    }
    CheckFrameDropRate.prototype.check = function (evt) {
        if (this.needIgnore(evt)) {
            return null;
        }
        if (this.needIgnoreBecausePlayTimeCloseToBuffer()) {
            return null;
        }
        if (this.checkFrameDrop()) {
            return this.getRetryConfig(evt.data.videoInfo, {
                degradeCodecExpireTime: this.superPlayer.config.maxDegradeCodecExpireTime,
                degradeReason: DEGRADE_CODEC_REASON.FRAME_DROP,
            });
        }
        return null;
    };
    CheckFrameDropRate.prototype.needIgnore = function (evt) {
        var _a;
        var videoInfo = evt.data.videoInfo;
        if (!this.superPlayer.config.enableDegradeOnLowPerformance
            || (!((_a = this.player) === null || _a === void 0 ? void 0 : _a.currentVideoInfo))
            || videoInfo.config.videoCodec === VIDEO_CODEC.H264 // 播放h.264时不检查
            || this.player.kernelName === KERNEL_NAME.WASM // wasm内核播放时由render-performance-checker检查
            || !this.canDegradeCodecDefn() // 4k、hdr这种清晰度，即使有性能问题也没法降级
        ) {
            return true;
        }
        if (this.isRetryedInSession) {
            // 性能问题导致的重试，在session内只能重试一次，并且后面就直接忽略了，不会终止播放
            return true;
        }
        return false;
    };
    /**
     * 播放时间非常靠近某个缓冲段的结束时，忽略帧率检测
     * 这个原因是发现chrome浏览器在hls内核播放时，如果出现缓冲，存在音频比视频缓冲更长，导致卡住时候声音在播画面卡死。例如视频缓冲到52秒，
     * 音频缓冲到54秒，当前播放时间是54秒。52->54秒之间播的时候，100%丢帧
     */
    CheckFrameDropRate.prototype.needIgnoreBecausePlayTimeCloseToBuffer = function () {
        var _a = this.player, playtime = _a.playtime, videoBuffered = _a.videoBuffered;
        for (var i = 0; i < videoBuffered.length; i++) {
            if (Math.abs(videoBuffered[i].end - playtime) < PLAY_TIME_2_BUFFER_MIN_GAP) {
                return true;
            }
        }
        return false;
    };
    CheckFrameDropRate.prototype.checkFrameDrop = function () {
        var _a;
        var maxFrameDropRate = this.superPlayer.config.maxFrameDropRate;
        var _b = (((_a = this.player.currentVideoInfo) === null || _a === void 0 ? void 0 : _a.qualityInfo) || {}).intervalFrameDropped, intervalFrameDropped = _b === void 0 ? 0 : _b;
        this.intervalFrameDroppedArr.push(intervalFrameDropped);
        if (this.intervalFrameDroppedArr.length >= DROP_FRAME_COUNT) {
            var avgFrameDropped = this.intervalFrameDroppedArr.reduce(function (prev, curr) { return prev + curr; }) / DROP_FRAME_COUNT;
            var intervalFrameDroppedArrForLog = [].concat(this.intervalFrameDroppedArr);
            // 清空
            this.intervalFrameDroppedArr.length = 0;
            // 丢帧率超过阀值降级
            if (avgFrameDropped >= maxFrameDropRate) {
                this.logger.log("dropframe rate ".concat(avgFrameDropped, " is more than ").concat(maxFrameDropRate, "\n        intervalFrameDroppedArrForLog=").concat(intervalFrameDroppedArrForLog));
                this.isRetryedInSession = true;
                return true;
            }
        }
        return false;
    };
    return CheckFrameDropRate;
}(SuperBaseCheck));

/**
 * 在播放非h.264编码时，出现原生播放的解码错误、不支持该音视频的错误，降级到h.264
 */
var CheckNoH264Error = /** @class */ (function (_super) {
    __extends(CheckNoH264Error, _super);
    function CheckNoH264Error() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckNoH264Error;
        _this.checkEvt = PLAY_EVENT.ERROR;
        return _this;
    }
    CheckNoH264Error.prototype.check = function (evt) {
        var _a, _b;
        var videoInfo = evt.data.videoInfo;
        var error = videoInfo.error;
        var enableDegradeOnLowPerformance = this.superPlayer.config.enableDegradeOnLowPerformance;
        if (this.isRetryedInSession) {
            // 一个session内只能降级一次
            return null;
        }
        if (!videoInfo.config || videoInfo.config.videoCodec === VIDEO_CODEC.H264 || !enableDegradeOnLowPerformance) {
            // 类似找不到内核之类的报错（没有走到创建kernel），可能没有urlConfig
            return null;
        }
        var code = (_b = (_a = error.code) === null || _a === void 0 ? void 0 : _a.split) === null || _b === void 0 ? void 0 : _b.call(_a, '.')[0];
        if (code !== ERROR_CODE.MEDIA_ERR_DECODE && code !== ERROR_CODE.MEDIA_ERR_SRC_NOT_SUPPORTED) {
            return null;
        }
        this.isRetryedInSession = true;
        return this.getRetryConfig(videoInfo, {
            degradeCodecExpireTime: 0,
            degradeReason: DEGRADE_CODEC_REASON.ORG_SPT_ERR,
        });
    };
    return CheckNoH264Error;
}(SuperBaseCheck));

var SuperCheckNormalError = /** @class */ (function (_super) {
    __extends(SuperCheckNormalError, _super);
    function SuperCheckNormalError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SuperCheckNormalError.prototype.getRetryConfig = function (videoInfo) {
        var result = _super.prototype.getRetryConfig.call(this, videoInfo);
        var maxRetryGetinfoTimes = this.player.config.maxRetryGetinfoTimes;
        var degradeReason = result.degradeReason || DEGRADE_CODEC_REASON.UNKNOWN;
        if (this.retryTimes === maxRetryGetinfoTimes) {
            // 最后一次重试，降级
            this.logger.log("degrade retry on last time[".concat(this.retryTimes, "/").concat(maxRetryGetinfoTimes, "]"), result);
            // h265 降级
            result.updatePlayParam.videoReqInfoParam.hevclv = HEVC_LV_VALUE.NOT_SPT;
            // av1 降级
            result.updatePlayParam.videoReqInfoParam.spav1 = 0;
            if (this.player.config.type === PLAY_MODE$1.VOD) {
                // mp4 降级
                result.updatePlayParam.videoReqInfoParam.dtype = 1;
            }
            else {
                // 直播的话最后一次使用默认清晰度，避免出现解码错误等重试后仍然无法成功播放
                result.updatePlayParam.videoReqInfoParam.defn = 'auto';
            }
            degradeReason = DEGRADE_CODEC_REASON.LAST;
        }
        return __assign(__assign({}, result), { degradeCodecExpireTime: 0, degradeReason: degradeReason });
    };
    return SuperCheckNormalError;
}(CheckNormalError));

/**
 * 如果是非wasm内核播放hevc视频出错（即浏览器原生支持hevc的播放），尝试使用wasm内核播放
 */
var CheckOriginPlayHevcError = /** @class */ (function (_super) {
    __extends(CheckOriginPlayHevcError, _super);
    function CheckOriginPlayHevcError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckOriginPlayHevcError;
        _this.checkEvt = PLAY_EVENT.ERROR;
        return _this;
    }
    CheckOriginPlayHevcError.prototype.check = function (evt) {
        var _a;
        var videoInfo = evt.data.videoInfo;
        var playtime = videoInfo.playtime, error = videoInfo.error;
        if (this.isRetryedInSession) {
            return null;
        }
        // 这里做一下兼容性的处理，高版本的core会抛出带有子码的错误码，但是这里只关心主错误码
        var code = (_a = error === null || error === void 0 ? void 0 : error.code) === null || _a === void 0 ? void 0 : _a.split('.')[0];
        if (!this.superPlayer.config.retryHevcByWasmIfOriginErr
            || !videoInfo.config
            || videoInfo.config.videoCodec !== VIDEO_CODEC.H265
            || this.player.kernelName === KERNEL_NAME.WASM
            || (code !== ERROR_CODE.MEDIA_ERR_DECODE && code !== ERROR_CODE.MEDIA_ERR_SRC_NOT_SUPPORTED)) {
            return null;
        }
        this.isRetryedInSession = true;
        return {
            error: error,
            updatePlayParam: {
                videoLoadParam: {
                    startTime: playtime,
                    kernelName: KERNEL_NAME.WASM,
                },
            },
        };
    };
    return CheckOriginPlayHevcError;
}(SuperBaseCheck));

/**
 * 检查渲染性能，当渲染性能低于配置的阀值时，需要重试播放。
 */
var CheckRenderPerformance = /** @class */ (function (_super) {
    __extends(CheckRenderPerformance, _super);
    function CheckRenderPerformance() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckRenderPerformance;
        _this.checkEvt = PLAY_EVENT.VIDEO_FRAME_RENDER;
        _this.lowRenderFrameCount = 0;
        _this.lowRenderFrameTimeCostArr = [];
        _this.renderTotalCount = 0;
        return _this;
    }
    CheckRenderPerformance.prototype.onSessionStart = function () {
        this.lowRenderFrameCount = 0;
        this.renderTotalCount = 0;
        _super.prototype.onSessionStart.call(this);
    };
    CheckRenderPerformance.prototype.check = function (evt) {
        var _a = this.superPlayer.config, minRenderFrameRate = _a.minRenderFrameRate, maxLowRenderFrameRate = _a.maxLowRenderFrameRate, enableDegradeOnLowPerformance = _a.enableDegradeOnLowPerformance, maxDegradeCodecExpireTime = _a.maxDegradeCodecExpireTime;
        var videoInfo = evt.data.videoInfo;
        var isValidConfig = minRenderFrameRate < 1
            && minRenderFrameRate > 0
            && maxLowRenderFrameRate < 1
            && maxLowRenderFrameRate > 0;
        if (!enableDegradeOnLowPerformance
            || !isValidConfig // 配置信息不正确
            || this.player.kernelName !== KERNEL_NAME.WASM
            || !this.canDegradeCodecDefn() // 4k、hdr这种清晰度，即使有性能问题也没法降级
        ) {
            return null;
        }
        var videoFrameRate = (this.player.currentVideoInfo || {}).videoFrameRate;
        if (!videoFrameRate || videoFrameRate < 0) {
            // 拿不到视频帧率时候也不用检查
            return null;
        }
        if (this.isRetryedInSession) {
            // 性能问题导致的重试，在session内只能重试一次。并且后面就直接忽略了，不会终止播放
            return null;
        }
        // 每帧渲染容忍的最低时长，例如40ms的渲染帧，只执行了30ms，那么代表已经发生丢帧
        var minRenderFrameCostTime = 1000 / videoFrameRate * minRenderFrameRate;
        var renderCostTime = evt.data.renderCostTime;
        // 记录一下帧渲染耗时
        this.lowRenderFrameTimeCostArr.push(renderCostTime);
        if (renderCostTime < minRenderFrameCostTime) {
            // 如果渲染耗时小于最大可容忍的渲染耗时，累加计数器
            this.lowRenderFrameCount++;
        }
        this.renderTotalCount++;
        if (this.renderTotalCount >= 1000) {
            var statsInfo = this.recordStats();
            // 统计达到1000帧时，计算低渲染帧的比例
            var lowRenderFrameRate = this.lowRenderFrameCount / this.renderTotalCount;
            // 统计达到1000帧时，重置累计器
            this.renderTotalCount = 0;
            this.lowRenderFrameCount = 0;
            // 如果低帧率比例超过能容忍的帧最低渲染耗时比例
            if (lowRenderFrameRate > maxLowRenderFrameRate) {
                this.logger.log("low render frame rate ".concat(lowRenderFrameRate, " is more than ").concat(maxLowRenderFrameRate));
                this.writeStats(statsInfo);
                this.isRetryedInSession = true;
                return this.getRetryConfig(videoInfo, {
                    degradeCodecExpireTime: maxDegradeCodecExpireTime,
                    degradeReason: DEGRADE_CODEC_REASON.WASM_RENDER,
                });
            }
        }
        return null;
    };
    /**
     * 覆盖父类方法，专门处理 WASM 性能问题导致的编码降级 & 内核降级
     */
    CheckRenderPerformance.prototype.getRetryConfig = function (videoInfo, degradeOpts) {
        var result = _super.prototype.getRetryConfig.call(this, videoInfo);
        var videoCodec = videoInfo.config.videoCodec;
        var nextVideoReqParam = __assign({}, result.updatePlayParam.videoReqInfoParam);
        // 检查是否能进行编码降级
        if (result && this.canDegradeCodecDefn()) {
            // 不管降级是因为播 266 还是播 265，由于 266 播放更消耗性能，因此一律都不让播 266 了
            nextVideoReqParam.spvvc = O266_LV_VALUE.NOT_SPT;
            // 播 265 导致的，不让播 265
            if (videoCodec === VIDEO_CODEC.H265) {
                nextVideoReqParam.hevclv = HEVC_LV_VALUE.NOT_SPT;
            }
            result.updatePlayParam.videoReqInfoParam = nextVideoReqParam;
            return __assign(__assign({}, result), degradeOpts);
        }
        // 其他情况下 fallback 回 base 来处理
        return _super.prototype.getRetryConfig.call(this, videoInfo, degradeOpts);
    };
    /**
     * 写入统计数据便于排查
     */
    CheckRenderPerformance.prototype.recordStats = function () {
        var _a = this.superPlayer.config, minRenderFrameRate = _a.minRenderFrameRate, maxLowRenderFrameRate = _a.maxLowRenderFrameRate;
        var statisticsInfo = {
            lowRenderFrameTimeCostArr: this.lowRenderFrameTimeCostArr.slice(-200),
            lowRenderFrameCount: this.lowRenderFrameCount,
            renderTotalCount: this.renderTotalCount,
            maxLowRenderFrameRate: maxLowRenderFrameRate,
            minRenderFrameRate: minRenderFrameRate,
        };
        this.lowRenderFrameTimeCostArr.length = 0;
        return statisticsInfo;
    };
    CheckRenderPerformance.prototype.writeStats = function (statsInfo) {
        // 这个ls的写入数据纯为了排查问题而记录在用户本地
        try {
            var statsInfoStr = JSON.stringify(statsInfo);
            lsTool.setData(LOCAL_STORAGE_KEY.RENDER_STATS_INFO, statsInfoStr);
        }
        catch (e) { }
    };
    return CheckRenderPerformance;
}(SuperBaseCheck));

/**
 * safari浏览器使用hls内核播放分辨率有变化的视频，会报错，回滚到原生播放
 * （测试视频https://thumbplayer-76307.gzc.vod.tencent-cloud.com/testvideo/hls/live-to-vod-safari-issue/f320092.ts.m3u8）
 */
var CheckSafariHlsError = /** @class */ (function (_super) {
    __extends(CheckSafariHlsError, _super);
    function CheckSafariHlsError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckSafariHlsError;
        _this.checkEvt = PLAY_EVENT.ERROR;
        return _this;
    }
    CheckSafariHlsError.prototype.check = function (evt) {
        var _a, _b;
        var videoInfo = evt.data.videoInfo;
        var playtime = videoInfo.playtime, error = videoInfo.error;
        if (this.isRetryedInSession) {
            return null;
        }
        // 这里做一下兼容性的处理，高版本的core会抛出带有子码的错误码，但是这里只关心主错误码
        var code = (_a = error === null || error === void 0 ? void 0 : error.code) === null || _a === void 0 ? void 0 : _a.split('.')[0];
        // 使用safari浏览器，hls内核，播放h.264视频，出现解码错误，需要判断
        var needCheck = uaTool.browser.safari
            && this.player.kernelName === KERNEL_NAME.HLS_JS
            && ((_b = videoInfo.config) === null || _b === void 0 ? void 0 : _b.videoCodec) === VIDEO_CODEC.H264
            && code === ERROR_CODE.MEDIA_ERR_DECODE;
        if (!needCheck) {
            return null;
        }
        this.isRetryedInSession = true;
        return {
            error: error,
            updatePlayParam: {
                videoLoadParam: {
                    startTime: playtime,
                    // 强行回滚到原生播放
                    kernelName: KERNEL_NAME.ORIGIN,
                },
            },
        };
    };
    return CheckSafariHlsError;
}(SuperBaseCheck));

/**
 * 检查wasm内核错误码，例如wasm内核抛出不支持，需要降级重试
 */
var CheckWasmError = /** @class */ (function (_super) {
    __extends(CheckWasmError, _super);
    function CheckWasmError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckWasmError;
        _this.checkEvt = PLAY_EVENT.ERROR;
        return _this;
    }
    CheckWasmError.prototype.check = function (evt) {
        var videoInfo = evt.data.videoInfo;
        var error = videoInfo.error;
        var code = error.code;
        if (this.isRetryedInSession) {
            return null;
        }
        // 这个是wasm-kernel里面的错误码，拿不到，所以在这里枚举下
        var WASM_NOT_SPT_ERROR = '70060003';
        if (!this.superPlayer.config.enableDegradeOnLowPerformance) {
            return null;
        }
        if (code !== WASM_NOT_SPT_ERROR) {
            // TODO：不是很确定wasm环境不支持，是不是就永久关闭wasm内核，因为wasm不支持的条件中，既有永久不支持的（例如sab,webassembly），还有
            // 动态不支持的（例如webgl，浏览器会有突然不支持webgl的case）
            // this.wirteDegradeExpireTimeToLocal();
            return null;
        }
        this.isRetryedInSession = true;
        return this.getRetryConfig(videoInfo, {
            degradeCodecExpireTime: 0,
            degradeReason: DEGRADE_CODEC_REASON.WASM_SPT_ERR,
        });
    };
    return CheckWasmError;
}(SuperBaseCheck));

/**
 * 降级编码播放的原因
 */
var DEGRADE_CODEC_REASON;
(function (DEGRADE_CODEC_REASON) {
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["UNKNOWN"] = 0] = "UNKNOWN";
    /** 丢帧 */
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["FRAME_DROP"] = 1] = "FRAME_DROP";
    /** wasm渲染性能 */
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["WASM_RENDER"] = 2] = "WASM_RENDER";
    /** wasm不支持 */
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["WASM_SPT_ERR"] = 3] = "WASM_SPT_ERR";
    /** 11102/11103报错 */
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["ORG_SPT_ERR"] = 4] = "ORG_SPT_ERR";
    /** 用户触发 */
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["USER"] = 5] = "USER";
    /** 最后一次兜底重试 */
    DEGRADE_CODEC_REASON[DEGRADE_CODEC_REASON["LAST"] = 6] = "LAST";
})(DEGRADE_CODEC_REASON || (DEGRADE_CODEC_REASON = {}));
/** 需要按多少帧来计算平均丢帧 */
var DROP_FRAME_COUNT = 60;
/** 播放时间点距离缓冲区结束的最近值 */
var PLAY_TIME_2_BUFFER_MIN_GAP = 3;
var RetryNames = {
    CheckFrameDropRate: 'CheckFrameDropRate',
    CheckNoH264Error: 'CheckNoH264Error',
    CheckOriginPlayHevcError: 'CheckOriginPlayHevcError',
    CheckRenderPerformance: 'CheckRenderPerformance',
    CheckSafariHlsError: 'CheckSafariHlsError',
    CheckWasmError: 'CheckWasmError',
};
/**
 * 重试的checker数组
 * 注意：判断走哪个重试策略，是有优先级的，因此数组有顺序要求
 */
var RetryClasses = [
    CheckFrameDropRate,
    CheckRenderPerformance,
    CheckWasmError,
    CheckOriginPlayHevcError,
    CheckSafariHlsError,
    CheckNoH264Error,
    SuperCheckNormalError,
];

/**
 * 写入localstorage当前降级时间戳，一定时间内不会再次请求非h.264播放
 */
function writeDegradeCodecToLocal(degradeExpireTime, degradeReason, extra) {
    var dataStr = JSON.stringify(__assign({ time: Date.now(), degradeExpireTime: degradeExpireTime, degradeReason: degradeReason }, extra));
    lsTool.setData(LOCAL_STORAGE_KEY.DEGRADE_CODEC_TIME, dataStr);
}
/**
 * 读取当前缓存中的降级信息
 * @returns 是否需要降级以及被降级原因
 */
function readDegradeCodecFromLocal() {
    var time = NaN;
    var degradeExpireTime = NaN;
    var degradeReason = DEGRADE_CODEC_REASON.UNKNOWN;
    try {
        var dataStr = lsTool.getData(LOCAL_STORAGE_KEY.DEGRADE_CODEC_TIME);
        var data = JSON.parse(dataStr || '{}');
        time = +data.time;
        degradeExpireTime = +data.degradeExpireTime;
        degradeReason = data.degradeReason;
    }
    catch (e) {
    }
    if (Number.isNaN(time) || Number.isNaN(degradeExpireTime) || Date.now() >= time + degradeExpireTime) {
        // 没有过期时间，或者当前时间已经超过过期时间，不需要降级
        return { needDegrade: false };
    }
    return { needDegrade: true, degradeReason: degradeReason };
}

var _a;
function collectDefaultField() {
    var allKey = Object.values(__assign(__assign(__assign({}, SuperStepKey), TvkStepKey), StepKey));
    var ret = allKey.reduce(function (map, key) {
        map[key] = 0;
        return map;
    }, {});
    delete ret[StepKey.CREATE_PLUGIN_PREFIX]; // 这个key是个前缀，不直接对应上报字段
    return ret;
}
var rptKeyMap = (_a = {},
    _a[CoreStepKey.SEL_KERNEL] = 's101',
    _a[CoreStepKey.LIC_REQ] = 's102',
    _a[CoreStepKey.LIC_REQ_SET] = 's103',
    _a[CoreStepKey.LIC_RES_SET] = 's104',
    _a[KernelStepKey.ATTACH_MEDIA] = 's105',
    _a[KernelStepKey.LOAD_MANIFAST] = 's106',
    _a[KernelStepKey.LOAD_CHUNK] = 's107',
    _a[KernelStepKey.TRANSMUX_CHUNK] = 's108',
    _a[KernelStepKey.APPEND_CHUNK] = 's109',
    _a);
/**
 * core和kernel的key到atta表的上报字段有一层转化，不能直接上报
 */
function convertCoreAndKernelKey(timingMap) {
    var keys = __spreadArray(__spreadArray([], Object.values(CoreStepKey), true), Object.values(KernelStepKey), true);
    keys.forEach(function (key) {
        timingMap[rptKeyMap[key]] = timingMap[key] || 0; // 补个默认值方便鹰眼算平均值
        delete timingMap[key];
    });
}
var isFirstVid = true;
var StepTimeRptPlugin = /** @class */ (function (_super) {
    __extends(StepTimeRptPlugin, _super);
    function StepTimeRptPlugin(player, config, extra) {
        var _this = _super.call(this, player, config, extra) || this;
        _this.REPORT_URL = 'https://h.trace.qq.com/kv?attaid=01000076328&token=3117637266';
        /** 在整个起播过程中，是否曾经处于页面被隐藏状态（因为被隐藏时测量时间并不准，上报时区分此状态） */
        _this.isOnceHidden = false;
        _this.visibleChangeHandler = function () {
            if (document.visibilityState === 'hidden') {
                _this.isOnceHidden = true;
            }
        };
        _this.onSessionFirstPlaying = function (_a) {
            var data = _a.data;
            var _b = Logger.timeEnd(_this.player.instanceId) || {}, _c = _b.cnt, logCnt = _c === void 0 ? 0 : _c, _d = _b.cost, logTime = _d === void 0 ? 0 : _d;
            StepTimer.end(SuperStepKey.FIRST_PLAYING, _this.player.instanceId);
            _this.end({
                logCnt: logCnt,
                logTime: logTime,
                hasAd: data.isAd ? 1 : 0,
            });
        };
        document.addEventListener('visibilitychange', _this.visibleChangeHandler);
        _this.player.pluginMsg.on(H5_EXT_EVENT.SESSION_FIRST_PLAYING, _this.onSessionFirstPlaying);
        return _this;
    }
    Object.defineProperty(StepTimeRptPlugin.prototype, "reportHeader", {
        get: function () {
            return {
                vid: this.player.vid,
                cid: this.player.getCommonKv(COMMON_DATA_KEY.cid) || '',
                flowid: this.player.getCommonKv(COMMON_DATA_KEY.flowid),
                guid: this.player.getCommonKv(COMMON_DATA_KEY.guid),
                appver: this.player.getCommonKv(COMMON_DATA_KEY.appVer),
                sd: this.player.getCommonKv(COMMON_DATA_KEY.isUseSrvData) ? 1 : 0,
                hassd: this.player.getCommonKv(COMMON_DATA_KEY.isSrvDataInvaild) ? 1 : 0,
                expid: cookieTool.get('tab_experiment_str') || '', // tab实验id
            };
        },
        enumerable: false,
        configurable: true
    });
    StepTimeRptPlugin.prototype.start = function () {
        Logger.timeStart(this.player.instanceId);
        StepTimer.start(SuperStepKey.FIRST_PLAYING, this.player.instanceId);
        this.isOnceHidden = false;
        this.visibleChangeHandler();
    };
    StepTimeRptPlugin.prototype.destroy = function () {
        var _a;
        document.removeEventListener('visibilitychange', this.visibleChangeHandler);
        if ((_a = this.player) === null || _a === void 0 ? void 0 : _a.pluginMsg) {
            this.player.pluginMsg.off(H5_EXT_EVENT.SESSION_FIRST_PLAYING, this.onSessionFirstPlaying);
        }
        _super.prototype.destroy.call(this);
    };
    StepTimeRptPlugin.prototype.end = function (data) {
        var _a = this.player.config, rptRate = _a.rptRate, instanceId = _a.instanceId;
        var recordMap = StepTimer.recordMap[instanceId];
        if (!recordMap) {
            return;
        }
        var reportInfo = this.createReportInfo(data);
        this.log('rpt=', reportInfo);
        isFirstVid = false;
        // 上报了就删掉当前播放器实例的耗时记录
        StepTimer.clean(instanceId);
        var isOfficialScenes = getIsOfficialScenes();
        if (!isOfficialScenes) {
            // 只有站内播放页上报
            return;
        }
        if (Math.random() > rptRate) {
            // 只采样部分用户
            return;
        }
        this.report(reportInfo);
    };
    StepTimeRptPlugin.prototype.createReportInfo = function (data) {
        var _a;
        var instanceId = this.player.config.instanceId;
        var globalStepTimeMap = isFirstVid ? StepTimer.timing() : undefined;
        var sessionStepTimeMap = StepTimer.timing(instanceId);
        if (sessionStepTimeMap) {
            // 转换正片起播过程中内核的打点字段（如果有广告，广告会再覆盖一次）
            convertCoreAndKernelKey(sessionStepTimeMap);
        }
        var reportInfo = __assign(__assign(__assign(__assign(__assign({}, collectDefaultField()), data), globalStepTimeMap), sessionStepTimeMap), { isFirstVid: isFirstVid ? 1 : 0, hided: this.isOnceHidden ? 1 : 0 });
        if (data.hasAd) {
            var cachesize = 0;
            var adPlayer = undefined;
            try {
                // copy自上报插件，需要传入广告类型
                adPlayer = getAdPlugin(instanceId).getPlayerInstance(AD_TYPE.PRE);
                cachesize = (_a = adPlayer.currentVideoInfo.cacheSize) !== null && _a !== void 0 ? _a : 0;
            }
            catch (e) { }
            if (adPlayer) {
                // 获取广告插件的KernelProxy的耗时打点数据
                var adSessionStepTimeMap = StepTimer.timing(adPlayer.config.instanceId);
                if (adSessionStepTimeMap) {
                    // 转换广告起播过程中内核的打点字段
                    convertCoreAndKernelKey(adSessionStepTimeMap);
                    Object.assign(reportInfo, adSessionStepTimeMap);
                }
                reportInfo.adKernel = adPlayer.kernelName === KERNEL_NAME.ORIGIN ? 1 : 0; // 广告是否使用原生内核
                reportInfo.adCache = cachesize > 0 ? 1 : 0; // 广告是否使用cache数据
            }
        }
        else {
            reportInfo.vKernel = this.player.kernelName;
        }
        return reportInfo;
    };
    StepTimeRptPlugin.pluginName = 'steptime-rpt';
    return StepTimeRptPlugin;
}(BaseReporter));
H5Player.registerPlugin(StepTimeRptPlugin.pluginName, StepTimeRptPlugin);

var VERSION$1 = getEnvVals().VERSION;
/** 默认生成的腾讯视频点播平台号 */
var defaultVodPlatform = getDefaultVodPlatform();
/** 默认生成的腾讯视频点播sdtfrom字段 */
var defautVodSdtfrom = getDefautVodSdtfrom(defaultVodPlatform);
var defaultVodBusinessConfig = {
    platform: defaultVodPlatform,
    sdtfrom: defautVodSdtfrom,
};
var defaultSuperConfig = {
    enableDegradeOnLowPerformance: true,
    maxDegradeCodecExpireTime: 0.5 * 24 * 3600 * 1000,
    // 降级播放的默认配置
    minRenderFrameRate: 0.8,
    maxLowRenderFrameRate: 0.3,
    maxFrameDropRate: 0.2,
    // 暂时默认开启
    enableTVK: true,
    enableP2P: true,
    proxyHttpPath: getTestProxyHttpPath(),
};
/**
 * 腾讯视频直播的平台号和sdtfrom默认写死
 * TODO：貌似体育的平台号是40201？？
 */
var defaultLiveBusinessConfig = {
    platform: OfficialPlatform.liveVQQ,
    sdtfrom: OfficialPlatform.liveVQQ,
};
function getBuiltInPlugins(type, config) {
    var _a;
    var _b;
    if (type === void 0) { type = PLAY_MODE.VOD; }
    var _c = config.removeComponents, removeComponents = _c === void 0 ? [] : _c;
    var disablePoster = removeComponents.includes(PosterPluginName) || !!config.disablePoster;
    var disableCtrlbar = removeComponents.includes(CtrlbarPluginName) || !!config.disableCtrlbar;
    var disableErrorPage = removeComponents.includes(ErrorPagePluginName) || !!config.disableErrorPage;
    var disableTips = removeComponents.includes(TipsPluginName) || !!config.disableTips;
    var disableLoading = removeComponents.includes(UILoadingPlugin.pluginName) || !!config.disableLoading;
    var disableCtxMenu = removeComponents.includes(UIContextMenuPluginName) || !!config.disableCtxMenu;
    var disableWatermark = removeComponents.includes(WatermarkPluginName) || !!config.disableWatermark;
    var disableInfoPanel = removeComponents.includes(InfoPanelPluginName);
    var pluginMap = (_a = {},
        _a[PosterPluginName] = { isEnabled: !disablePoster, config: config.poster },
        _a[CtrlbarPluginName] = { isEnabled: !disableCtrlbar },
        _a[ErrorPagePluginName] = { isEnabled: !disableErrorPage, config: { showOnError: true } },
        _a[TipsPluginName] = { isEnabled: !disableTips },
        _a[UILoadingPlugin.pluginName] = { isEnabled: !disableLoading },
        _a[UIContextMenuPluginName] = {
            // 移动端不需要右键菜单插件
            isEnabled: !isMobile && !disableCtxMenu,
            config: { menus: [{ role: 'version', label: VERSION$1 || '1.3.0' }] },
        },
        _a[InfoPanelPluginName] = { isEnabled: !disableInfoPanel, config: { defaultInfo: true } },
        _a[LivepollPlugin.pluginName] = {
            isEnabled: type === PLAY_MODE.LIVE,
            config: { livepid: (_b = config.livepollConfig) === null || _b === void 0 ? void 0 : _b.livepid },
        },
        _a[WatermarkPluginName] = { isEnabled: !disableWatermark },
        _a[StepTimeRptPlugin.pluginName] = { isEnabled: type === PLAY_MODE.VOD },
        _a);
    var plugins = [];
    Object.keys(pluginMap).forEach(function (pluginName) {
        var _a = pluginMap[pluginName], isEnabled = _a.isEnabled, config = _a.config;
        if (isEnabled) {
            plugins.push(!config ? pluginName : [pluginName, config]);
        }
    });
    return plugins;
}
function getSuperConfig(config) {
    var _a, _b, _c;
    var _d = config.plugins, plugins = _d === void 0 ? [] : _d, _e = config.mode, mode = _e === void 0 ? PLAY_MODE.VOD : _e, _f = config.businessConfig, businessConfig = _f === void 0 ? {} : _f, _g = config.coreConfig, coreConfig = _g === void 0 ? {} : _g, _h = config.pluginConfig, pluginConfig = _h === void 0 ? {} : _h, _j = config.dynamicConfig, dynamicConfig = _j === void 0 ? {} : _j;
    config.type = (_a = config.type) !== null && _a !== void 0 ? _a : mode;
    var type = config.type;
    var defaultBusinessConf = type === PLAY_MODE.VOD ? defaultVodBusinessConfig : defaultLiveBusinessConfig;
    var buzConfig = __assign(__assign({}, defaultBusinessConf), businessConfig);
    var builtInPlugins = getBuiltInPlugins(type, config);
    var playerPlugins = __spreadArray(__spreadArray([], builtInPlugins, true), plugins, true);
    var platform = buzConfig.platform;
    var superPlayerConfig = __assign(__assign(__assign(__assign(__assign(__assign({}, defaultSuperConfig), { supportedPaidFormat: isOfficialSite()
            ? [PAID_FORMAT.FHD, PAID_FORMAT.DOLBY, PAID_FORMAT.SFR_HDR, PAID_FORMAT.UHD] : [], logLevel: getLogLevelFromUrl(), 
        // 这里解构顺序是为了让config中未拍平的配置优先级高于pluginConfig和coreConfig
        videoElementConfig: {
            playsinline: true,
        }, 
        // 使用两个videoNode目前只为了切换清晰度不黑屏。但在移动端使用两个video标签存在一些兼容性问题，因此在移动端默认用1个video标签。
        // 目前发现移动端用多个video标签的时候可能存在以下问题：
        // 1. 无法同时播放
        // 2. ios15.0黑屏
        // 3. 微信浏览器自动播放时，点击都无法起播
        maxVideoNodeCount: (isMobile || type === PLAY_MODE.LIVE) ? 1 : 2, watermarkConfig: {}, enableCreativePlugin: true, getUserCookieForPlayback: getLogintoken }), pluginConfig), coreConfig), config), { businessConfig: buzConfig, plugins: playerPlugins, offlineConfig: __assign({ platform: platform }, config.offlineConfig), getinfoConfig: __assign({}, config.getinfoConfig), errorPageConfig: __assign({ useBrowserTip: isOfficialSite(), useClientBtn: isOfficialSite() }, config.errorPageConfig), ctrlConfig: __assign(__assign({ disableNextBtn: true, hidePopupOnClick: true }, pluginConfig.ctrlConfig), config.ctrlConfig), infoPanelConfig: __assign({ defaultInfo: true }, config.infoPanelConfig), vodQaReporterConfig: __assign(__assign({}, config === null || config === void 0 ? void 0 : config.vodQaReporterConfig), { paramsKey: __assign(__assign({}, (_b = pluginConfig.vodQaReporterConfig) === null || _b === void 0 ? void 0 : _b.paramsKey), (_c = config === null || config === void 0 ? void 0 : config.vodQaReporterConfig) === null || _c === void 0 ? void 0 : _c.paramsKey) }), tvkConfig: __assign({ 
            // 仅10201点播默认使用TEE
            enableTEE: platform === OfficialPlatform.vodVQQ && type === PLAY_MODE.VOD, 
            // 2023-09 收到外网反馈windows 11 AMD Ryzen 5系下集显出现HEVC播放时画面颜色异常，因此暂时默认配置关闭
            hevcGPUBlackList: {
                'edg<118': [
                    'AMD Radeon\\(TM\\) Graphics',
                    'AMD Radeon\\(TM\\) Vega \\d+ Graphics', // amd集显卡
                ],
            } }, config.tvkConfig) });
    if (config.isPrivateDeployment) {
        superPlayerConfig.enableTVK = false;
    }
    var result = {
        superPlayerConfig: mergeDynamicConfig(superPlayerConfig, getLocalDynamicConfig() || dynamicConfig),
    };
    return result;
}
function getAdInitConfig(config) {
    var _a;
    var _b = config.adKernelName, adKernelName = _b === void 0 ? KERNEL_NAME.DEMUX_2_FMP4 : _b, adInitConfig = config.adInitConfig, useSingleVideoElement = config.useSingleVideoElement;
    var hasInstalledDemuxKernel = !!KernelFactory.getKernelByName(KERNEL_NAME.DEMUX_2_FMP4);
    var isUseDemuxKernel = !uaTool.browser.safari
        && hasInstalledDemuxKernel
        && adKernelName === KERNEL_NAME.DEMUX_2_FMP4;
    return __assign(__assign({}, adInitConfig), { playerData: __assign(__assign({}, adInitConfig === null || adInitConfig === void 0 ? void 0 : adInitConfig.playerData), { 
            // 移动端默认使用单 video 模式
            playerVideoDom: (useSingleVideoElement !== null && useSingleVideoElement !== void 0 ? useSingleVideoElement : uaTool.mobile) ? (_a = config.videoElements) === null || _a === void 0 ? void 0 : _a[0] : undefined }), isUseDemuxKernel: isUseDemuxKernel, opencache: isUseDemuxKernel });
}
/**
 * 从localstorage中获取动态配置。这个配置信息由播放器的前置脚本从服务器拉取并写入。
 */
function getLocalDynamicConfig() {
    var superPlayerDynamicConfigId = window.SUPER_PLAYER_DYNAMIC_CONFIG_ID;
    if (!superPlayerDynamicConfigId) {
        // 页面没有给全局动态配置id
        return null;
    }
    try {
        var localDataStr = lsTool.getData(LOCAL_STORAGE_KEY.DYNAMIC_CONFIG);
        if (!localDataStr) {
            // 本地没缓存
            return null;
        }
        var localData = JSON.parse(localDataStr);
        var localAppData = localData[superPlayerDynamicConfigId];
        if (!(localAppData === null || localAppData === void 0 ? void 0 : localAppData.app_config) || localAppData.app_config === '{}' || localAppData.app_config === '') {
            // 本地缓存中没有页面指定的id的动态配置信息
            return null;
        }
        var localAppDynamicConfig = JSON.parse(localAppData.app_config);
        return localAppDynamicConfig;
    }
    catch (e) {
    }
    return null;
}
/** 处理dynamicConfig，对象属性合并，其他覆盖 */
function mergeDynamicConfig(config, dynamicConfig) {
    var superConfig = config;
    Object.keys(dynamicConfig).forEach(function (key) {
        var value = superConfig[key];
        if (Object.prototype.toString.call(value) === '[object Object]') {
            superConfig[key] = __assign(__assign({}, value), dynamicConfig[key]);
        }
        else {
            superConfig[key] = dynamicConfig[key];
        }
    });
    return superConfig;
}

/** 获取编译注入变量值 */
var envVals = getEnvVals();
/** 广告插件初始化defer。用局部变量保存，保证只加载一次 */
var adInitDefer;
var logMethodCall = logMethodCallDecoratorCreator('SuperPlayer');
var performanceCost = performanceCostDecoratorCreator('SuperPlayer');
/** hls中插偏移值, 单位秒 */
var hlsADShift = 1;
var SuperPlayer = /** @class */ (function (_super) {
    __extends(SuperPlayer, _super);
    function SuperPlayer(config) {
        var _this = this;
        var _a, _b;
        StepTimer.end(SuperStepKey.READY_2_NEW);
        // 提前创建播放器实例id，否则默认创建会等到创建core的实例时。
        var instanceId = (_a = config.instanceId) !== null && _a !== void 0 ? _a : commonTool.createGUID();
        StepTimer.start(SuperStepKey.NEW, instanceId);
        var superPlayerConfig = getSuperConfig(config).superPlayerConfig;
        superPlayerConfig.instanceId = instanceId;
        if (!superPlayerConfig.isPrivateDeployment) {
            // 采集引用上报信息
            var reporter = ReferenceReport.getReporter();
            // from定义2标识为superplayer
            reporter.collectUsage(2, envVals.CHANNEL, (_b = superPlayerConfig.businessConfig) === null || _b === void 0 ? void 0 : _b.platform);
        }
        _this = _super.call(this, superPlayerConfig) || this;
        /** 直播/点播 */
        _this.type = PLAY_MODE.VOD;
        /** 根据vvip信息修改传入的startTime(减去广告时间)，同时允许通过keepOriginalStartTime参数指定不修改 */
        _this.videoLoadParamModifier = function (param) {
            var _a, _b;
            if (_this.config.keepOriginalStartTime)
                return param;
            var startTime = param.startTime;
            // 将起点限制在试看范围内
            if (_this.previewDuration > 0) {
                // startTime = Math.min(
                //   this.previewDuration + this.previewStartPosition,
                //   Math.max(this.previewStartPosition, startTime),
                // );
                // case 1：startTime超过了试看区，从试看区的开头进行播放
                // case 2: startTime小于试看区的开头，从试看区的开头进行播放
                if (startTime > _this.previewDuration + _this.previewStartPosition
                    || startTime < _this.previewStartPosition) {
                    startTime = _this.previewStartPosition;
                }
            }
            // 如果存在中插广告，且playtime指定到了中插广告的内部，跳到开头
            var hlsAdRanges = (_a = _this.getCommonKv(SUPER_DATA_KEY.hlsAdRanges)) !== null && _a !== void 0 ? _a : [];
            var rangeAtPlaytime = commonTool.findDiscontinuityTimeRangeAtPlaytime(startTime, hlsAdRanges);
            if (rangeAtPlaytime && startTime) {
                var newStartTime = rangeAtPlaytime.start - hlsADShift;
                _this.log("start time modified due to hls ad, origin: ".concat(startTime, ", new: ").concat(newStartTime));
                return __assign(__assign({}, param), { startTime: newStartTime });
            }
            // vvip相关逻辑
            if (!((_b = _this.removedAdRange) === null || _b === void 0 ? void 0 : _b.length)) {
                return __assign(__assign({}, param), { startTime: startTime });
            }
            return __assign(__assign({}, param), { startTime: _this.getVVIPOffsetTime(startTime) });
        };
        _this.logger = new Logger(_this.config.instanceId, 'SuperPlayer');
        _this.log('new SuperPlayer(), input config=', config);
        var _c = config.mode, mode = _c === void 0 ? PLAY_MODE.VOD : _c, type = config.type;
        _this.type = (type || mode);
        _this.adLogic = new AdLogic(_this, _this.corePlayer);
        _this.previewLogic = new PreviewLogic(_this);
        _this.posterLogic = new PosterLogic(_this);
        if (COOKIE_AVAILABLE_HOSTS.indexOf(location.host) !== -1 && _this.type === PLAY_MODE.VOD) {
            _this.cookieLogic = new CookieLogic(_this);
        }
        _this.writeGlobalCommonKvs();
        _this.initPlugins();
        _this.initInnerEvts();
        _this.reqExtInfoOnMobile();
        _this.setupRemovedAdRange();
        if (getDebugModeFromUrl()) {
            SuperPlayer._instances[_this.config.instanceId] = _this;
        }
        if (config.videoId || config.adInitConfig) {
            _this.loadAdPlugin();
        }
        if (superPlayerConfig.enableTVK) {
            _this.tvk = enableTVK(_this, superPlayerConfig.tvkConfig);
        }
        _this.timeEnd(SuperStepKey.NEW);
        _this.timeStart(SuperStepKey.NEW_2_PLAY);
        return _this;
    }
    Object.defineProperty(SuperPlayer.prototype, "vinfo", {
        /** 当前的播放信息 */
        get: function () {
            return this.currentVideoInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "ctrlbarPlugin", {
        /** 控制栏插件 */
        get: function () {
            return this.plugins[CtrlbarPluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "tipsPlugin", {
        /** 提示信息插件 */
        get: function () {
            return this.plugins[TipsPluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "loadingPlugin", {
        /** 加载图标插件 */
        get: function () {
            return this.plugins[UILoadingPlugin.pluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "errorPagePlugin", {
        /** 错误页插件 */
        get: function () {
            return this.plugins[ErrorPagePluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "posterPlugin", {
        /** 封面图插件 */
        get: function () {
            return this.plugins[PosterPluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "config", {
        /** 配置参数 */
        get: function () {
            // 加了个空对象防销毁后报错
            return (this.corePlayer.config || {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "previewDuration", {
        /** 试看时长 */
        get: function () {
            return this.previewLogic.previewDuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "previewStartPosition", {
        /** 试看起点 */
        get: function () {
            return this.previewLogic.previewStartPosition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "core", {
        /** @deprecated */
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "coreConfig", {
        /** @deprecated changed to player.config */
        get: function () {
            return this.config;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "levelList", {
        /** 清晰度列表 */
        get: function () {
            return this.getCommonKv(COMMON_DATA_KEY.currentDefnList);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "level", {
        /** 当前清晰度 */
        get: function () {
            return this.getCommonKv(COMMON_DATA_KEY.currentDefn);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "stepTimeRptPlugin", {
        /** 统计起播耗时的上报插件 */
        get: function () {
            return this.plugins[StepTimeRptPlugin.pluginName];
        },
        enumerable: false,
        configurable: true
    });
    SuperPlayer.prototype.log = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.logger).log.apply(_a, args);
    };
    SuperPlayer.prototype.warn = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.logger).warn.apply(_a, args);
    };
    Object.defineProperty(SuperPlayer.prototype, "videoSize", {
        get: function () {
            var _a;
            return this.videoSizeFromGetInfo || ((_a = this.corePlayer) === null || _a === void 0 ? void 0 : _a.videoSize) || { width: 0, height: 0 };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SuperPlayer.prototype, "cnlid", {
        /** 腾讯视频直播流id */
        get: function () {
            if (this.config.type === PLAY_MODE.LIVE) {
                return this.vid;
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 降编码重播
     * @param degradeCodecExpireTime 过期时长（单位毫秒），例如hevc降级到h.264播放，效果持续1天，则传入1 * 24 * 3600 * 1000。如果不传或传0，则本地不记录
     * @returns 成功执行重播
     */
    SuperPlayer.prototype.degradeCodecRetry = function (degradeCodecExpireTime) {
        var _a;
        if (degradeCodecExpireTime === void 0) { degradeCodecExpireTime = 0; }
        return (_a = this.startGetinfoRetry) === null || _a === void 0 ? void 0 : _a.call(this, {
            updatePlayParam: {
                videoReqInfoParam: {
                    hevclv: HEVC_LV_VALUE.NOT_SPT,
                },
                videoLoadParam: {
                    startTime: this.playtime,
                    // VideoFlowNode缓存了上一次kernelName，导致降级还会走到wasm内核，比较恶心，后续重构loadParam这一块
                    kernelName: void 0,
                },
            },
            degradeCodecExpireTime: degradeCodecExpireTime,
            degradeReason: DEGRADE_CODEC_REASON.USER,
        }, false);
    };
    /**
     * 删除播放器缓存在localstorage中的数据
     * @param localKey localstorage的key字符串
     * @returns 是否成功删除
     */
    SuperPlayer.prototype.clearLocalstorage = function (localKey) {
        var keyIdx = Object.keys(LOCAL_STORAGE_KEY).findIndex(function (key) { return LOCAL_STORAGE_KEY[key] === localKey; });
        if (keyIdx !== -1) {
            // 只能删除被定义的合法key
            lsTool.delData(localKey);
            return true;
        }
        return false;
    };
    SuperPlayer.prototype.destroy = function () {
        var _a, _b, _c, _d, _e, _f;
        (_a = this.tvk) === null || _a === void 0 ? void 0 : _a.destroy();
        this.tvk = null;
        (_b = this.adLogic) === null || _b === void 0 ? void 0 : _b.destroy();
        this.adLogic = null;
        (_c = this.previewLogic) === null || _c === void 0 ? void 0 : _c.destroy();
        this.previewLogic = null;
        (_d = this.posterLogic) === null || _d === void 0 ? void 0 : _d.destroy();
        this.posterLogic = null;
        (_e = this.cookieLogic) === null || _e === void 0 ? void 0 : _e.destroy();
        this.cookieLogic = null;
        // 可能重复销毁
        if (((_f = this.config) === null || _f === void 0 ? void 0 : _f.instanceId) && SuperPlayer._instances[this.config.instanceId]) {
            delete SuperPlayer._instances[this.config.instanceId];
        }
        return _super.prototype.destroy.call(this);
    };
    // 播控接口，这里分vid和url的版本
    /** 播放，支持指定起播时间点和强制指定内核。
     *
     * 1. 传参为空时执行播放器原生的play方法。
     * 2. 如果有传入vid/cnlid，且加载了getinfo插件时，播控交由getinfo插件实现（id换取url播放）。
     * 3. 传入urlConfig时，直接播放url。
     * @param config {PlayInfoConfig} 需要加载的视频信息（支持url/vid点播/cnlid直播）
     * @param extra 额外配置信息，支持指定起播时间和指定播放内核
     * @returns void
     */
    SuperPlayer.prototype.play = function (playConfig, param) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var centerBtn;
            return __generator(this, function (_e) {
                if (!playConfig) {
                    return [2 /*return*/, this.playByInitConfig()];
                }
                this.timeEnd(SuperStepKey.NEW_2_PLAY);
                (_a = this.stepTimeRptPlugin) === null || _a === void 0 ? void 0 : _a.start();
                (_b = this.tipsPlugin) === null || _b === void 0 ? void 0 : _b.hide();
                (_c = this.loadingPlugin) === null || _c === void 0 ? void 0 : _c.show();
                centerBtn = (_d = this.ctrlbarPlugin) === null || _d === void 0 ? void 0 : _d.instances.CenterBtn;
                if (centerBtn) {
                    centerBtn.hideEl(centerBtn.playBtn);
                }
                return [2 /*return*/, this.loadOrPlay(playConfig, param, 'play')];
            });
        });
    };
    /**
     * 内部调用视频加载逻辑，播放器load/play接口共用这个方法的逻辑
     * @param funcName 真正调用此逻辑的方法名，因为play接口中复用了load的逻辑，因此在play接口中调用loadInner传入的是'play'
     */
    SuperPlayer.prototype.loadOrPlay = function (playConfig, param, funcName) {
        var _a, _b, _c;
        if (funcName === void 0) { funcName = 'load'; }
        return __awaiter(this, void 0, void 0, function () {
            var paramErrMsg, config, prePlayConfig, prePlayConfig, _d, vid, cnlid, livepid, extra, buildinVideoReqInfoParam, playUrlConfig;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!playConfig) {
                            return [2 /*return*/];
                        }
                        paramErrMsg = checkParams(this.type, funcName, playConfig);
                        if (paramErrMsg) {
                            this.logger.error(paramErrMsg, playConfig);
                            (_a = this.errorPagePlugin) === null || _a === void 0 ? void 0 : _a.show({
                                text: paramErrMsg,
                                hideRefresh: true,
                            });
                            return [2 /*return*/];
                        }
                        // 这个函数执行要早于上一次的playSessionEnd事件。因为目前情况下，如果在播放中重新调用play接口，上一次播放需要在h5player创建节点时才会
                        // 停止播放，当收到上一次的playSessionEnd事件时，这个函数中获取getinfo请求参数之类的逻辑已经走完，因此会有上一次播放残留的参数污染这一
                        // 次播放。
                        // 暂时用clearBeforeReplay函数来提前清理各种参数等。最好的办法其实是在这里await stop()函数。但是修改后发现单测中有很多非法调用（也许
                        // 引用方也是这样调用的），例如play以后马上replay，而不是await play以后replay。这种非法调用在增加await stop以后会出现很多错误。因此
                        // 做了妥协。
                        this.clearBeforeReplay();
                        config = playConfig;
                        // 记录用户的原始播放参数，重播时候直接传入
                        this.replayConfig = playConfig;
                        if (typeof playConfig === 'string') {
                            // 处理传入"b00249eiunm"和{ vid: "b00249eiunm" }的情况，相当于格式化参数
                            if (this.type === PLAY_MODE.LIVE) {
                                prePlayConfig = ((_b = this.currentPlayItem) === null || _b === void 0 ? void 0 : _b.cnlid) ? this.currentPlayItem : {};
                                config = __assign(__assign({}, prePlayConfig), { cnlid: playConfig });
                            }
                            else {
                                prePlayConfig = ((_c = this.currentPlayItem) === null || _c === void 0 ? void 0 : _c.vid) ? this.currentPlayItem : {};
                                config = __assign(__assign({}, prePlayConfig), { vid: playConfig });
                            }
                        }
                        _d = config, vid = _d.vid, cnlid = _d.cnlid, livepid = _d.livepid;
                        extra = this.isH5PlayParam(param) ? param : { videoLoadParam: param };
                        // 记录h5player层的当前播放参数（字符串或者IUrlConfig）
                        this.currentPlayItem = vid || cnlid || config;
                        this.playtimeLimiter.clearAllConfig();
                        if (!(hasGetinfoModule(this.config.instanceId) && (vid || cnlid))) return [3 /*break*/, 5];
                        this.timeStart(SuperStepKey.PREPARE_REQ);
                        buildinVideoReqInfoParam = void 0;
                        // 有没有srvData都先设置没用srvData，后续解析以后还可能抛弃掉srvData数据
                        this.setCommonKv(COMMON_DATA_KEY.isUseSrvData, false);
                        this.setCommonKv(COMMON_DATA_KEY.isSrvDataInvaild, false);
                        if (!extra.srvData) return [3 /*break*/, 1];
                        // 如果外部传入了播放数据，不需要计算请求参数了
                        this.logger.log('skip builtin param');
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getBuiltInVideoReqInfoParam(config)];
                    case 2:
                        // 请求getinfo前，准备一些内置的请求参数
                        buildinVideoReqInfoParam = _e.sent();
                        if (this._destroyed) {
                            // await过程中都有可能出现播放器被销毁的情况
                            return [2 /*return*/];
                        }
                        _e.label = 3;
                    case 3:
                        this.timeEnd(SuperStepKey.PREPARE_REQ);
                        extra.videoReqInfoParam = __assign(__assign({}, buildinVideoReqInfoParam), extra.videoReqInfoParam);
                        this.timeStart(SuperStepKey.LOAD_AD_PLUGIN);
                        return [4 /*yield*/, this.loadAdPlugin()];
                    case 4:
                        _e.sent();
                        this.timeEnd(SuperStepKey.LOAD_AD_PLUGIN);
                        if (this._destroyed) {
                            return [2 /*return*/];
                        }
                        // 指定cnlid时 更新轮询插件的pid
                        if (cnlid) {
                            extra.videoReqInfoParam.cnlid = cnlid;
                            // 就算没有livepid也设置，此时不会发起轮询
                            this.getPlugin(LivepollPlugin.pluginName).livepid = livepid;
                            this.setCommonKv(COMMON_DATA_KEY.livepid, livepid);
                        }
                        else if (vid) {
                            extra.videoReqInfoParam.vid = vid;
                        }
                        return [2 /*return*/, _super.prototype[funcName].call(this, vid || cnlid, extra)];
                    case 5:
                        playUrlConfig = config;
                        this.setLevelOptions(playUrlConfig.levels, playUrlConfig.url);
                        return [2 /*return*/, _super.prototype[funcName].call(this, playUrlConfig, extra)];
                }
            });
        });
    };
    SuperPlayer.prototype.replay = function () {
        var _a, _b, _c, _d, _e, _f;
        (_b = (_a = this.loadParam) === null || _a === void 0 ? void 0 : _a.videoLoadParam) === null || _b === void 0 ? true : delete _b.startTime;
        (_c = this.loadParam) === null || _c === void 0 ? true : delete _c.srvData;
        var defn = this.getCommonKv(COMMON_DATA_KEY.currentDefn);
        if (this.vid && defn) {
            // replay vid 时需要记住清晰度 defn 参数
            return this.play(this.replayConfig, __assign(__assign({}, this.loadParam), { videoReqInfoParam: __assign(__assign(__assign({}, (_d = this.loadParam) === null || _d === void 0 ? void 0 : _d.videoReqInfoParam), (_f = (_e = this.config).getUserCookieForPlayback) === null || _f === void 0 ? void 0 : _f.call(_e)), { // 重新获取登陆态
                    defn: defn }) }));
        }
        return this.play(this.replayConfig, this.loadParam);
    };
    /**
     * 加载，仅支持点播模式。支持指定起播时间点和强制指定内核。
     * 1. 传参为空时执行播放器原生的play方法
     * 2. 如果有传入vid/cnlid，且加载了getinfo插件时，播控交由getinfo插件实现（id换取url播放）
     * 3. 传入urlConfig时，直接播放url
     * @param config {PlayInfoConfig} 需要加载的视频信息（支持url/vid点播/cnlid直播）
     * @param extra 额外配置信息，支持指定起播时间和指定播放内核
     */
    SuperPlayer.prototype.load = function (config, param) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!config)
                    return [2 /*return*/, _super.prototype.load.call(this)];
                return [2 /*return*/, this.loadOrPlay(config, param, 'load')];
            });
        });
    };
    /**
     * 预加载，仅支持点播模式。支持指定起播时间点和强制指定内核。
     *
     * @param config {PlayInfoConfig} 需要加载的视频信息（支持vid点播）
     * @param extra 额外配置信息，支持指定起播时间和指定播放内核
     * @param endTime 视频结束时间，以此来判断预加载结束时间
     */
    SuperPlayer.prototype.preload = function (config, param, endTime) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var paramErrMsg, loadVid, extra, buildinVideoReqInfoParam;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!config)
                            return [2 /*return*/];
                        paramErrMsg = checkParams(this.type, 'load', config);
                        if (paramErrMsg) {
                            this.logger.error(paramErrMsg, config);
                            (_a = this.errorPagePlugin) === null || _a === void 0 ? void 0 : _a.show({
                                text: paramErrMsg,
                                hideRefresh: true,
                            });
                            return [2 /*return*/];
                        }
                        loadVid = typeof config === 'string' ? config : config === null || config === void 0 ? void 0 : config.vid;
                        extra = this.isH5PlayParam(param) ? param : { videoLoadParam: param };
                        if (!hasGetinfoModule(this.config.instanceId) || !loadVid)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.getBuiltInVideoReqInfoParam(config, false)];
                    case 1:
                        buildinVideoReqInfoParam = _b.sent();
                        if (this._destroyed) {
                            return [2 /*return*/];
                        }
                        extra.videoReqInfoParam = __assign(__assign({}, buildinVideoReqInfoParam), extra === null || extra === void 0 ? void 0 : extra.videoReqInfoParam);
                        return [2 /*return*/, _super.prototype.preload.call(this, loadVid, extra, endTime)];
                }
            });
        });
    };
    /** Seek 操作，如果在有试看时 seek，则会在下一次timeupdate直接判定试看是否结束 */
    SuperPlayer.prototype.seek = function (time) {
        var seekTargetTime = time;
        var hlsMidRollAdRange = this.getCommonKv(SUPER_DATA_KEY.hlsAdRanges);
        if (hlsMidRollAdRange) {
            // 检查当前时间点是否在中插内
            var isCurrentTimeInAdRange = commonTool.findDiscontinuityTimeRangeAtPlaytime(this.playtime + hlsADShift, // 因为可能的seek点是广告开头 - shift，这里做一点容错避免反复跳
            hlsMidRollAdRange);
            // 如果seek到hls中插段内，调整时间点为广告开始位置
            var rangeIncludesTargetTime = commonTool.findDiscontinuityTimeRangeAtPlaytime(seekTargetTime, hlsMidRollAdRange);
            if (rangeIncludesTargetTime && !isCurrentTimeInAdRange) {
                // 如果目标时间点是广告，而当前时间点在广告外，跳到广告开头
                seekTargetTime = rangeIncludesTargetTime.start - hlsADShift;
            }
        }
        return _super.prototype.seek.call(this, seekTargetTime);
    };
    /**
     * 切换清晰度
     *
     * 1. 如果有getinfo插件且使用vid/cnlid播放，则切换清晰度交由getinfo插件实现。
     * 2. 通过url切换清晰度需要先在清晰度列表中添加指定的url。
     * @param defn {string} 切换到的清晰度名称
     * @param extra.userTrigger 是否用户触发的切换清晰度
     */
    SuperPlayer.prototype.setLevel = function (defn, extra) {
        var _a, _b, _c;
        if (extra === void 0) { extra = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var prevDefn_1, commonParam, setLevelReqParam, liveParam, vodParam, getinfoAdInfo, _d, audioTracks, currentAudioTrack_1, track, hardSetLevelFormats, setLevelMode, currentDefnList, nextLevelIndex, nextLevelObj, nextUrls;
            var _this = this;
            return __generator(this, function (_e) {
                if (typeof defn !== 'string') {
                    return [2 /*return*/, Promise.reject('setLevel received illegal parameter')];
                }
                if (hasGetinfoModule(this.config.instanceId) && this.vid) {
                    if (this.state === VIDEO_STATE.PAUSE && this.type === PLAY_MODE.VOD) {
                        // 点播下切换清晰度直接开播
                        this.play();
                    }
                    prevDefn_1 = this.getCommonKv(COMMON_DATA_KEY.currentDefn);
                    if (extra.userTrigger) {
                        // 如果是用户操作的切换清晰度，缓存起来
                        this.setCommonKv(PersistedUserSettings.definition, defn);
                        // 因为支持直出服务只能读取cookie数据的原因，在cookie也存一下
                        (_a = this.cookieLogic) === null || _a === void 0 ? void 0 : _a.setDefn(defn);
                    }
                    commonParam = __assign({ defn: defn }, (_c = (_b = this.config).getUserCookieForPlayback) === null || _c === void 0 ? void 0 : _c.call(_b));
                    setLevelReqParam = void 0;
                    if (this.type === PLAY_MODE.LIVE) {
                        liveParam = __assign(__assign({}, commonParam), { 
                            // 如果非用户触发的切换清晰度可自动降级
                            defnswitch: extra.userTrigger ? 1 : 0 });
                        // defauto是兼容旧重定向接口
                        Object.assign(liveParam, {
                            defauto: +!liveParam.defnswitch,
                        });
                        setLevelReqParam = liveParam;
                    }
                    else {
                        vodParam = __assign({ 
                            // 如果非用户触发的切换清晰度可自动降级
                            fhdswitch: extra.userTrigger ? 1 : 0 }, commonParam);
                        getinfoAdInfo = this.getCommonKv(SUPER_DATA_KEY.getinfoAdInfo);
                        if (getinfoAdInfo) {
                            vodParam.adsid = getinfoAdInfo.adsid || '';
                            vodParam.adpinfo = getinfoAdInfo.adpinfo || '';
                        }
                        _d = this.currentVideoInfo, audioTracks = _d.audioTracks, currentAudioTrack_1 = _d.currentAudioTrack;
                        if (audioTracks.length > 1) {
                            track = audioTracks.find(function (item) { return item.id === currentAudioTrack_1; });
                            // 切换清晰度时携带多音轨信息
                            track && Object.assign(vodParam, {
                                track: track.name,
                            });
                        }
                        setLevelReqParam = vodParam;
                    }
                    hardSetLevelFormats = [FORMAT.DOLBY, FORMAT.HDR10, FORMAT.SFR_HDR];
                    setLevelMode = extra.setLevelMode;
                    if (hardSetLevelFormats.indexOf(prevDefn_1) !== -1 || hardSetLevelFormats.indexOf(defn) !== -1) {
                        // 判断如果是hdr等特殊清晰度相关的切换，都使用硬切
                        setLevelMode = SET_LEVEL_MODE.HARD;
                    }
                    return [2 /*return*/, _super.prototype.setLevel.call(this, setLevelReqParam, { setLevelMode: setLevelMode }).catch(function (err) {
                            _this.log(err);
                            if (_this._destroyed) {
                                return;
                            }
                            // 回滚当前清晰度
                            if (_this.ctrlbarPlugin) {
                                _this.ctrlbarPlugin.level = prevDefn_1;
                            }
                            _this.setCommonKv(COMMON_DATA_KEY.currentDefn, prevDefn_1);
                        })];
                }
                currentDefnList = this.getCommonKv(COMMON_DATA_KEY.currentDefnList);
                nextLevelIndex = currentDefnList === null || currentDefnList === void 0 ? void 0 : currentDefnList.findIndex(function (item) { return item.value === defn; });
                nextLevelObj = currentDefnList[nextLevelIndex];
                if (!nextLevelObj)
                    return [2 /*return*/, Promise.reject(new Error('no definition info'))];
                nextUrls = nextLevelObj.url;
                if (!nextUrls && this.defnIdToUrl) {
                    nextUrls = this.defnIdToUrl(defn);
                    nextLevelObj.url = nextUrls;
                }
                if (!nextUrls)
                    return [2 /*return*/, Promise.reject(new Error('definition must contains url'))];
                this.setCommonKv(COMMON_DATA_KEY.currentDefn, defn);
                // 更新重播地址
                this.replayConfig.url = nextUrls;
                return [2 /*return*/, _super.prototype.setLevel.call(this, __assign(__assign({}, this.replayConfig), { defn: nextLevelObj.value, url: nextLevelObj.url, level: nextLevelObj, levelIndex: nextLevelIndex }))];
            });
        });
    };
    /**
     * 获取指定插件
     * @param name 插件名（Plugin.pluginName）
     */
    SuperPlayer.prototype.getPlugin = function (name) {
        return this.plugins[name];
    };
    /**
     * 此方法为播放器的付费逻辑行为。跳过广告、切换清晰度等如果触发付费行为，外部可能拉起弹窗并暂停当前播放。
     * 如果观看者关掉弹窗，引用方需要调用此方法，使播放器恢复播放或其他行为。
     * <br>
     * 以广告播放为例，广告插件配置传入的回调函数参数`showOpenVIPGuide`。当前贴广告播放时，用户点击了右上角的“跳过广告”按钮，此时广告插件会调
     * 用`showOpenVIPGuide`方法，页面在此方法中拉起了一个付费弹窗用于提示用户进行付费等行为，并且暂停了广告播放。如果用户选择关闭此弹窗，播放
     * 器需要恢复广告播放，因此页面需要调用此方法恢复正常广告播放。
     */
    SuperPlayer.prototype.closePayTipsCallback = function (type) {
        var adPlugin = getAdPlugin(this.config.instanceId);
        if (type === 'ad' && typeof (adPlugin === null || adPlugin === void 0 ? void 0 : adPlugin.resumeAd) === 'function') {
            try {
                adPlugin.resumeAd();
            }
            catch (e) {
                this.logger.error('closePayTipsCallback, call adPlugin::resumeAd', e);
            }
        }
    };
    SuperPlayer.prototype.createPlugin = function (insName, option) {
        if (option === void 0) { option = {}; }
        var _a = option.pluginName, pluginName = _a === void 0 ? insName : _a;
        if (pluginName === AdPluginName) {
            _super.prototype.createPlugin.call(this, insName, __assign(__assign({}, option), { requestProxyHttp: this.requestAdCallback4AdPlugin.bind(this) }));
        }
        else {
            _super.prototype.createPlugin.call(this, insName, option);
        }
    };
    SuperPlayer.prototype.setAdConfig = function (config) {
        return this.loadAdPlugin().then(function (ad) { var _a; return (_a = ad === null || ad === void 0 ? void 0 : ad.setConf) === null || _a === void 0 ? void 0 : _a.call(ad, config); });
    };
    /** 调节container尺寸时需要调用此方法，同步更新广告尺寸 */
    SuperPlayer.prototype.resizeAd = function () {
        return this.loadAdPlugin().then(function (ad) { var _a; return (_a = ad === null || ad === void 0 ? void 0 : ad.resizeAd) === null || _a === void 0 ? void 0 : _a.call(ad); });
    };
    /** 如果调节container尺寸是异步的，在resize前可以调用这个方法先隐藏广告；resize完成后再调用resizeAd展示广告 */
    SuperPlayer.prototype.hideAdBeforeResize = function () {
        return this.loadAdPlugin().then(function (ad) { var _a; return (_a = ad === null || ad === void 0 ? void 0 : ad.hideAdBeforeResize) === null || _a === void 0 ? void 0 : _a.call(ad); });
    };
    /** 输入原播放时间，输出减去或者加上广告后的时间
     * @param playtime 原播放时间
     * @param isPlus 是否反向计算、加上广告时长，默认是减去广告时长
     */
    SuperPlayer.prototype.getVVIPOffsetTime = function (playtime, isPlus) {
        if (isPlus === void 0) { isPlus = false; }
        var removedAdRange = this.removedAdRange;
        if (!(removedAdRange === null || removedAdRange === void 0 ? void 0 : removedAdRange.length))
            return playtime;
        if (isPlus)
            return this.getPlusAdOffsetTime(playtime);
        /** 需要减去的时间 */
        var skipTime = 0;
        for (var i = 0; i < removedAdRange.length; i++) {
            var _a = removedAdRange[i], start = _a.start, end = _a.end;
            if (start > playtime)
                break;
            if (end > playtime) {
                // 落在广告内，返回广告开始的时间点(减去已播放的广告时长)
                skipTime += (playtime - start);
                break;
            }
            else {
                skipTime += end - start;
            }
        }
        return playtime - skipTime;
    };
    SuperPlayer.prototype.startGetinfoRetry = function (retryConfig, fatal) {
        var _a, _b, _c;
        var _d = retryConfig.degradeCodecExpireTime, degradeCodecExpireTime = _d === void 0 ? 0 : _d, _e = retryConfig.degradeReason, degradeReason = _e === void 0 ? DEGRADE_CODEC_REASON.UNKNOWN : _e;
        if (degradeReason === DEGRADE_CODEC_REASON.USER) {
            // 用户触发重试，再检查下是否可以重试，其他reason不需要再走这个判断了
            if (!this.canGetinfoRetry()) {
                return false;
            }
        }
        // 重新获取cookie
        commonTool.merge(retryConfig, {
            updatePlayParam: {
                videoReqInfoParam: __assign({}, (_b = (_a = this.config).getUserCookieForPlayback) === null || _b === void 0 ? void 0 : _b.call(_a)),
            },
        });
        if (degradeCodecExpireTime > 0) {
            // 写入这些信息便于记录降级时播放器的一些信息
            var extraInfo = {
                playerSize: domTool.getDomSize(this.player.container),
                videoSize: this.player.videoSize,
                url: location.href,
                topUrl: urlTool.getTopFrameUrl(),
                kernelName: this.player.kernelName,
                flowid: this.player.getCommonKv(COMMON_DATA_KEY.flowid),
                guid: this.player.getCommonKv(COMMON_DATA_KEY.guid),
                playtime: this.player.playtime,
                duration: this.player.duration,
                vid: this.player.vid,
                loadingUrl: (_c = this.player.currentVideoInfo) === null || _c === void 0 ? void 0 : _c.loadingUrl,
            };
            this.logger.log("start degrade retry, degradeReason=".concat(degradeReason, ", extraInfo="), extraInfo);
            // 写入localstorage记录超时时间
            writeDegradeCodecToLocal(degradeCodecExpireTime, degradeReason, extraInfo);
        }
        return _super.prototype.startGetinfoRetry.call(this, retryConfig, fatal);
    };
    SuperPlayer.prototype.getRetryCheckClasses = function () {
        return RetryClasses;
    };
    /** 加上广告时长后，需要存储的原始时间 */
    SuperPlayer.prototype.getPlusAdOffsetTime = function (playtime) {
        return this.removedAdRange.reduce(function (prev, cur) {
            var start = cur.start, end = cur.end;
            if (start <= prev) {
                prev += end - start;
            }
            return prev;
        }, playtime);
    };
    SuperPlayer.prototype.playByInitConfig = function () {
        var _a = this.config, videoId = _a.videoId, _b = _a.videoInitConfig, videoInitConfig = _b === void 0 ? videoId : _b;
        // 这里的判断条件为config中没有videoId且当前没有通过其他途径设置过playItem(load,play接口)
        if (!videoInitConfig || this.currentPlayItem)
            return _super.prototype.play.call(this);
        return this.play(videoInitConfig);
    };
    /** 插入到后贴之前的合并接口节点。url模式不插入 */
    SuperPlayer.prototype.nodeBeforePostAd = function (reqInfo) {
        if (!uaTool.mobile && this.previewLogic.previewDuration !== NO_PREVIEW_FLAG) {
            // pc端试看不请求后贴
            return null;
        }
        return _super.prototype.nodeBeforePostAd.call(this, reqInfo);
    };
    SuperPlayer.prototype.setupRemovedAdRange = function () {
        var _this = this;
        this.on(H5_PLAY_EVENT.VIDEO_REQ_INFO_END, function (_a) {
            var data = _a.data;
            if (data.code !== ErrorCode.SUC || _this.config.type === PLAY_MODE.LIVE)
                return;
            try {
                var _b = data.data, parseData = _b.parseData, reqParams = _b.reqParams;
                var _c = parseData.vitem, pureVid = _c.purevid, _d = _c.dotinfo, dotInfo = _d === void 0 ? '' : _d;
                if (pureVid && reqParams.vid !== pureVid && dotInfo) {
                    _this.removedAdRange = JSON.parse(dotInfo).dot_time.map(function (v) { return ({
                        start: +v.start_time / 1000,
                        end: +v.end_time / 1000,
                    }); });
                }
                else {
                    _this.removedAdRange = null;
                }
            }
            catch (err) {
                _this.log('set ad range err,', err);
                _this.removedAdRange = null;
            }
        });
    };
    SuperPlayer.prototype.selectGetinfoModule = function (config) {
        var _a = config.type, type = _a === void 0 ? PLAY_MODE.VOD : _a, getinfoModule = config.getinfoModule, enableTVK = config.enableTVK;
        if (!enableTVK) {
            return null;
        }
        var targetReqPlugin;
        if (getinfoModule) {
            return getinfoModule;
        }
        if (type === PLAY_MODE.VOD) {
            targetReqPlugin = VodGetinfo;
        }
        else {
            targetReqPlugin = LiveGetinfo;
        }
        return targetReqPlugin;
    };
    SuperPlayer.prototype.initPlugins = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.initAdPlugin();
                this.initErrorPage();
                this.initTipsPlugin();
                this.initCtrlbarPlugin();
                this.initLivepoll();
                this.initLoadingPlugin();
                this.clearCache();
                return [2 /*return*/];
            });
        });
    };
    SuperPlayer.prototype.initAdPlugin = function () {
        var _this = this;
        var ctrlbarPlugin = this.ctrlbarPlugin;
        if (!ctrlbarPlugin)
            return;
        // 全屏变化时调用resizeAd
        ctrlbarPlugin.on(CTRL_EVENTS.FAKE_FULLSCREEN_CHANGE, function () { return _this.resizeAd(); });
        ctrlbarPlugin.on(CTRL_EVENTS.FULLSCREEN_CHANGE, function () {
            // 系统全屏是异步操作，先隐藏角标广告 等全屏后再展示
            _this.hideAdBeforeResize();
            var fullscreenFinishDelay = 300;
            setTimeout(function () {
                _this.resizeAd();
            }, fullscreenFinishDelay);
        });
    };
    SuperPlayer.prototype.reqExtInfoOnMobile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, videoId, _b, enableGetExtInfo, platform, duration;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.config, videoId = _a.videoId, _b = _a.enableGetExtInfo, enableGetExtInfo = _b === void 0 ? true : _b;
                        if (!enableGetExtInfo || !uaTool.mobile || typeof videoId !== 'string')
                            return [2 /*return*/];
                        platform = this.getCommonKv(COMMON_DATA_KEY.platform);
                        return [4 /*yield*/, requestVideoExtInfo({ vid: videoId, platform: platform })];
                    case 1:
                        duration = (_c.sent()).duration;
                        if (this.state === VIDEO_STATE.IDLE
                            && !this.played
                            && this.ctrlbarPlugin) {
                            this.ctrlbarPlugin.duration = duration;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SuperPlayer.prototype.initLoadingPlugin = function () {
        var _this = this;
        // 为了降低复杂度，loading动画在super-player统一控制，因此插件中不会监听各种事件来处理loading动画的显隐
        this.on(H5_PLAY_EVENT.VIDEO_SETLEVEL_START, function () { var _a; return (_a = _this.loadingPlugin) === null || _a === void 0 ? void 0 : _a.show(); });
        this.on(H5_PLAY_EVENT.VIDEO_SETLEVEL_END, function () { var _a; return (_a = _this.loadingPlugin) === null || _a === void 0 ? void 0 : _a.hide(); });
        this.pluginMsg.on(H5_EXT_EVENT.RETRY_PLAY, function (_a) {
            var _b, _c;
            var data = _a.data;
            // 播放级别重试时，可能先会长时间停留在getinfo阶段，因此先展示loading动画
            (_b = _this.loadingPlugin) === null || _b === void 0 ? void 0 : _b.show();
            // 降级播放的tips将语意模糊一下
            (_c = _this.tipsPlugin) === null || _c === void 0 ? void 0 : _c.show({
                text: !!(data === null || data === void 0 ? void 0 : data.degradeReason)
                    ? t(i18nConfig.superPlayer.TIPS_DEGRADE_TEXT_REASON)
                    : t(i18nConfig.superPlayer.TIPS_DEGRADE_TEXT_NO_REASON),
                time: -1, // 重试过程中tips保持不消失
            });
        });
        this.pluginMsg.on(H5_EXT_EVENT.RETRY_PLAY_SUCC, function () {
            var _a;
            (_a = _this.tipsPlugin) === null || _a === void 0 ? void 0 : _a.hide();
        });
    };
    SuperPlayer.prototype.initLivepoll = function () {
        var _this = this;
        var livepoll = this.plugins[LivepollPlugin.pluginName];
        if (!livepoll)
            return;
        livepoll.on(LIVE_EVENTS.statusChange, function (_a) {
            var _b;
            var data = _a.data;
            if (data.new === LIVE_STATUS.OVER) {
                (_b = _this.errorPagePlugin) === null || _b === void 0 ? void 0 : _b.show({
                    text: t(i18nConfig.superPlayer.LIVE_STREAM_END),
                    hideRefresh: true,
                });
            }
        });
    };
    SuperPlayer.prototype.initErrorPage = function () {
        var _this = this;
        if (!this.errorPagePlugin)
            return;
        var i18nSuperConfig = i18nConfig.superPlayer;
        this.errorPagePlugin.on(ErrorPagePluginEvents.REPORT_LOG, function () { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.offlineLog.reportLogs({
                                reportSource: 'error-page:click',
                            })];
                    case 1:
                        _c.sent();
                        (_a = this.tipsPlugin) === null || _a === void 0 ? void 0 : _a.show(t(i18nSuperConfig.ERROR_PAGE_REPORT_SUCCESS));
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _c.sent();
                        (_b = this.tipsPlugin) === null || _b === void 0 ? void 0 : _b.show(t(i18nSuperConfig.ERROR_PAGE_REPORT_FAILED, err_1 === null || err_1 === void 0 ? void 0 : err_1.message));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    SuperPlayer.prototype.initTipsPlugin = function () {
        var _this = this;
        if (!this.tipsPlugin)
            return;
        this.on(H5_PLAY_EVENT.VIDEO_SETLEVEL_END, function (_a) {
            var _b, _c, _d;
            var data = _a.data;
            if (data.code !== ErrorCode.SUC) {
                // 因为无法切换时抛出来的错误信息是开发术语，如果切换失败，不需要提示用户。（但会reject错误信息）
                return;
            }
            var defn = _this.getCommonKv(COMMON_DATA_KEY.currentDefn);
            var urlLevel = (_b = _this.levelList) === null || _b === void 0 ? void 0 : _b.find(function (v) { return v.value === defn; });
            var urlLevelName = ((_d = (_c = urlLevel === null || urlLevel === void 0 ? void 0 : urlLevel.payload) === null || _c === void 0 ? void 0 : _c.trim) === null || _d === void 0 ? void 0 : _d.call(_c)) || (urlLevel === null || urlLevel === void 0 ? void 0 : urlLevel.label);
            _this.tipsPlugin.show(t(i18nConfig.superPlayer.DEFN_SWITCH_SUCCESS, urlLevelName));
        });
    };
    SuperPlayer.prototype.initCtrlbarPlugin = function () {
        var _this = this;
        var superI18nConfig = i18nConfig.superPlayer;
        if (!this.ctrlbarPlugin)
            return;
        this.ctrlbarPlugin.level = this.getCommonKv(COMMON_DATA_KEY.currentDefn);
        this.ctrlbarPlugin.audio = this.getCommonKv(COMMON_DATA_KEY.currentAudioTrack);
        this.ctrlbarPlugin.lang = this.getCommonKv(COMMON_DATA_KEY.currentSubtitle);
        this.pluginMsg.on(H5_EXT_EVENT.DATASET_UPDATE, function (e) {
            var data = e.data;
            var key = data.key, newVal = data.newVal, oldVal = data.oldVal;
            if (newVal === oldVal)
                return;
            var list;
            switch (key) {
                case COMMON_DATA_KEY.currentAudioTrackList:
                    _this.ctrlbarPlugin.audioOpts = newVal;
                    break;
                case COMMON_DATA_KEY.currentAudioTrack:
                    _this.ctrlbarPlugin.audio = newVal;
                    break;
                case COMMON_DATA_KEY.currentDefn:
                    _this.ctrlbarPlugin.level = newVal;
                    break;
                case COMMON_DATA_KEY.currentDefnList:
                    if (!newVal || newVal.length <= 1) {
                        _this.ctrlbarPlugin.levelOpts = [];
                        break;
                    }
                    list = [].concat(newVal);
                    _this.ctrlbarPlugin.levelOpts = list;
                    break;
            }
        });
        this.ctrlbarPlugin.on(CTRL_EVENTS.SET_LEVEL, function (param) {
            var _a, _b;
            if (!_this.checkCanSetLevel())
                return;
            var _c = param.data, value = _c.value, payload = _c.payload, label = _c.label;
            // 切换清晰度的tips持久化，直到切换完成。
            (_a = _this.tipsPlugin) === null || _a === void 0 ? void 0 : _a.show({
                text: t(superI18nConfig.DEFN_SWITCHING, ((_b = payload === null || payload === void 0 ? void 0 : payload.trim) === null || _b === void 0 ? void 0 : _b.call(payload)) || label),
                time: -1,
            });
            _this.setLevel(value, { userTrigger: true });
        });
        var onSetAudioTrackFail = function () {
            _this.tipsPlugin.show(t(superI18nConfig.AUDIO_SWITCH_FAILED));
            _this.ctrlbarPlugin.audio = _this.currentVideoInfo.currentAudioTrack;
        };
        var onSetAudioTrackSuccess = function (label) {
            _this.tipsPlugin.show(t(superI18nConfig.AUDIO_SWITCH_SUCCESS, label));
        };
        this.ctrlbarPlugin.on(CTRL_EVENTS.SET_AUDIO, function (param) {
            var _a;
            var _b = param.data, label = _b.label, value = _b.value;
            (_a = _this.tipsPlugin) === null || _a === void 0 ? void 0 : _a.show({
                text: t(superI18nConfig.AUDIO_SWITCHING, label),
                time: -1,
            });
            _this.setAudioTrack(value)
                .then(function (_a) {
                var fail = _a.fail;
                if (fail)
                    onSetAudioTrackFail();
                else
                    onSetAudioTrackSuccess(label);
            })
                .catch(function () {
                onSetAudioTrackFail();
            });
        });
        this.on(PLAY_EVENT.SET_AUDIO_TRACK_OVER, function (evt) {
            _this.setCommonKv(COMMON_DATA_KEY.currentAudioTrack, evt.data.id);
        });
        this.ctrlbarPlugin.on(CTRL_EVENTS.TEST_EVENT, function () {
            var _a;
            (_a = _this.getPlugin(InfoPanelPluginName)) === null || _a === void 0 ? void 0 : _a.show();
        });
    };
    /**
     * 鼠标隐藏的条件，基于原本的逻辑添加：
     * 指针 Hover 在控制栏时不隐藏
     */
    SuperPlayer.prototype.shouldHideMouse = function () {
        // 如果没有控制栏，则按原逻辑处理
        if (!this.ctrlbarPlugin) {
            return _super.prototype.shouldHideMouse.call(this);
        }
        var _a = (this.ctrlbarPlugin.instances.CtrlShow || {}).isMouseHoverControl, isMouseHoverControl = _a === void 0 ? false : _a;
        return _super.prototype.shouldHideMouse.call(this) && !isMouseHoverControl;
    };
    SuperPlayer.prototype.setLevelOptions = function (urlLevels, playUrl) {
        var _a;
        if (urlLevels) {
            var list = urlLevels.list;
            var defaultLevel = ((_a = list.find(function (i) { return i.default || i.url === playUrl; })) === null || _a === void 0 ? void 0 : _a.value) || list[0].value;
            this.setCommonKv(COMMON_DATA_KEY.currentDefn, defaultLevel);
            this.setCommonKv(COMMON_DATA_KEY.currentDefnList, list);
            this.defnIdToUrl = urlLevels.callback;
        }
        else {
            // 上一个urlConfig可能有传levels了然后被cache了，所以下一个urlConfig可能需要清除cache
            this.setCommonKv(COMMON_DATA_KEY.currentDefn, void 0);
            this.setCommonKv(COMMON_DATA_KEY.currentDefnList, void 0);
            this.defnIdToUrl = void 0;
        }
    };
    /** 判断入参是否h5player层定义的load参数 */
    SuperPlayer.prototype.isH5PlayParam = function (config) {
        if (config === void 0) { config = {}; }
        var h5config = config;
        return !!(h5config.videoReqInfoParam
            || h5config.videoLoadParam
            || h5config.adParam
            || h5config.playTimeLimit
            || h5config.srvData);
    };
    SuperPlayer.prototype.initInnerEvts = function () {
        var _this = this;
        this.pluginMsg.on(H5_EXT_EVENT.GETINFO_OVER, function (_a) {
            var _b;
            var data = _a.data;
            var resData = (data || {}).resData;
            var vi = (((_b = resData === null || resData === void 0 ? void 0 : resData.vl) === null || _b === void 0 ? void 0 : _b.vi) || [])[0];
            if (vi) {
                var vw = vi.vw, vh = vi.vh;
                // 在getinfo返回里面尝试取一下视频分辨率
                _this.videoSizeFromGetInfo = { width: vw, height: vh };
            }
        });
        // 移动端限播时，提前加载后贴cgi
        if (uaTool.mobile) {
            this.on(H5_PLAY_EVENT.VIDEO_TIMEUPDATE, function (_a) {
                var data = _a.data;
                if (_this.previewDuration === NO_PREVIEW_FLAG)
                    return;
                var postAdPreloadTime = 10;
                if (data.playtime >= _this.previewDuration - postAdPreloadTime) {
                    // 这里会预加载后贴节点。移动端默认使用单 video 模式，不会实际预加载广告视频
                    _this.loadPostAd();
                }
            });
        }
        this.on(H5_PLAY_EVENT.PLAY_SESSION_END, function (_a) {
            var data = _a.data;
            if (data.code === ErrorCode.SRV_DATA_INVAILD) {
                _this.logger.log('replay when srvData invaild');
                _this.replay();
                // 在replay以后再设置，因为每次播放都会重置这个状态。而只有这里会设置这个状态为true
                _this.setCommonKv(COMMON_DATA_KEY.isSrvDataInvaild, true);
            }
        });
    };
    /**
     * 写入一些静态的全局变量到数据中心，这些数据在播放器销毁时都不会变化。
     */
    SuperPlayer.prototype.writeGlobalCommonKvs = function () {
        // 这里 appVer 字段定为 super-player 版本号
        // 在生产环境 rollup 打包时注入为 @tencent/super-player 下 package.json 的 version 字段
        // 而在 super-demo 下跑 demo 时，则注入为 super-demo/package.json 的 version 字段
        this.setCommonKv(COMMON_DATA_KEY.appVer, envVals.VERSION);
        this.setCommonKv(this.config.businessConfig);
        this.writeLoginCommonKV();
    };
    SuperPlayer.prototype.getDefnNameById = function (id) {
        var _a, _b;
        var defn = (_b = (_a = this.getinfoCtx) === null || _a === void 0 ? void 0 : _a.parseData) === null || _b === void 0 ? void 0 : _b.definitionList.find(function (v) { return v.name === id; });
        if (defn) {
            var _c = formatDefnName(defn.cname, this.type === PLAY_MODE.LIVE), _d = _c[0], nameC = _d === void 0 ? '' : _d, _e = _c[1], nameN = _e === void 0 ? '' : _e;
            return "".concat(nameN, " ").concat(nameC).trim();
        }
        return '';
    };
    SuperPlayer.prototype.requestProxyHttpOnlyAd = function (adType, adReqParam) {
        return __awaiter(this, void 0, void 0, function () {
            var adPlugin, adRequestor, adReqParams, proxyHttpCtx, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        adPlugin = getAdPlugin(this.config.instanceId);
                        if (!adPlugin)
                            return [2 /*return*/];
                        adRequestor = new ProxyHttp(this.config, { pluginMsg: this.pluginMsg });
                        adReqParams = getAdReqParams(this.config.instanceId, __assign({ vid: this.curReqInfo.vid, adType: adType }, adReqParam));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, adRequestor.request(adReqParams, null)];
                    case 2:
                        proxyHttpCtx = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.warn("proxyhttp request err in catch, ".concat(e_1));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, proxyHttpCtx];
                }
            });
        });
    };
    /** 传给广告插件使用 */
    SuperPlayer.prototype.requestAdCallback4AdPlugin = function (adType, adReqParam) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var adPlugin, proxyHttpCtx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        adPlugin = getAdPlugin(this.config.instanceId);
                        if (!adPlugin)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.requestProxyHttpOnlyAd(adType, adReqParam)];
                    case 1:
                        proxyHttpCtx = _b.sent();
                        if ((_a = proxyHttpCtx === null || proxyHttpCtx === void 0 ? void 0 : proxyHttpCtx.parseData) === null || _a === void 0 ? void 0 : _a.ad) {
                            // 请求到数据以后把广告订单再设置到 reqInfo 缓存
                            try {
                                adPlugin.setAdInfo(proxyHttpCtx.parseData.ad);
                            }
                            catch (e) {
                                this.logger.error('requestAd, call adPlugin::setAdInfo', e);
                            }
                        }
                        return [2 /*return*/, proxyHttpCtx];
                }
            });
        });
    };
    SuperPlayer.prototype.requestAdCallback = function (adType, adReqParam) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var ctx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.requestProxyHttpOnlyAd(adType, adReqParam)];
                    case 1:
                        ctx = _b.sent();
                        return [2 /*return*/, (_a = ctx === null || ctx === void 0 ? void 0 : ctx.parseData) === null || _a === void 0 ? void 0 : _a.ad];
                }
            });
        });
    };
    SuperPlayer.prototype.stop = function (endState) {
        this.videoSizeFromGetInfo = null;
        return _super.prototype.stop.call(this, endState);
    };
    SuperPlayer.prototype.emit = function (event, eventObject) {
        return _super.prototype.emit.call(this, event, eventObject);
    };
    SuperPlayer.prototype.on = function (event, listener, priority) {
        return _super.prototype.on.call(this, event, listener, priority);
    };
    SuperPlayer.prototype.once = function (event, listener) {
        return _super.prototype.once.call(this, event, listener);
    };
    SuperPlayer.prototype.off = function (event, listener) {
        return _super.prototype.off.call(this, event, listener);
    };
    SuperPlayer.prototype.listeners = function (event) {
        return _super.prototype.listeners.call(this, event);
    };
    SuperPlayer.prototype.listenerCount = function (event) {
        return _super.prototype.listenerCount.call(this, event);
    };
    /** 将登录态相关cookie写入数据中心 */
    SuperPlayer.prototype.writeLoginCommonKV = function () {
        var _a, _b;
        var _c;
        var getCookie = function (key) { return cookieTool.get(key); };
        // 以下逻辑参考自txplayer/v4-h5-report.js
        var authData = getUserCookies();
        this.setCommonKv((_a = {},
            _a[COMMON_DATA_KEY.hc_main_login] = authData[COOKIE_NAME.MAIN_LOGIN],
            _a[COMMON_DATA_KEY.hc_vuserid] = authData[COOKIE_NAME.VUSERID],
            _a[COMMON_DATA_KEY.hc_openid] = authData[COOKIE_NAME.OPENID],
            _a[COMMON_DATA_KEY.hc_appid] = authData[COOKIE_NAME.APPID],
            _a[COMMON_DATA_KEY.hc_access_token] = authData[COOKIE_NAME.ACCESS_TOKEN],
            _a));
        var guid = authData[COOKIE_NAME.GUID] || cookieTool.get(COOKIE_NAME.GUID);
        if (guid) {
            this.setCommonKv(COMMON_DATA_KEY.guid, guid);
            lsTool.setData(LOCAL_KEY.GUID, guid);
        }
        var isQQ = authData[COOKIE_NAME.MAIN_LOGIN] === 'qq';
        var qqNum = (_c = (getCookie('luin') || getCookie('uin'))) === null || _c === void 0 ? void 0 : _c.replace(/\D/g, '').replace(/^0+/, '');
        this.setCommonKv((_b = {},
            _b[COMMON_DATA_KEY.loginid] = isQQ ? qqNum : getCookie('openid'),
            _b[COMMON_DATA_KEY.loginex] = isQQ ? getCookie('openid') : qqNum,
            _b));
        var loginType = { qq: 1, wx: 2 };
        this.setCommonKv(COMMON_DATA_KEY.logintype, loginType[authData[COOKIE_NAME.MAIN_LOGIN]] || 0);
        this.setCommonKv(COMMON_DATA_KEY.hc_vuession, authData[COOKIE_NAME.VUSESSION]);
    };
    SuperPlayer.prototype.loadAdPlugin = function () {
        var _this = this;
        var _a = this.config.enableCreativePlugin, enableCreativePlugin = _a === void 0 ? true : _a;
        // 域名白名单内不加载任何广告
        if (!enableCreativePlugin || envVals.LOCAL_DEV || isInDomainWhiteList) {
            return Promise.resolve(null);
        }
        var adInitConfig = getAdInitConfig(this.config);
        var isAdPluginLoaded = !!H5Player.getPlugin(AdPluginName);
        // 从来没有尝试加载过广告插件
        if (!adInitDefer) {
            if (isAdPluginLoaded) {
                // 1. 已经加载ok（可能播放器已经加载过了，或者页面已经提前加载过了）
                adInitDefer = Promise.resolve();
            }
            else {
                // 2. 发起真实请求去加载广告插件的cdn资源
                // 站内允许自定义广告插件版本号
                var adPluginVersion = isOfficialDomain() && this.config.adVersion ? this.config.adVersion : adVersion;
                adInitDefer = this.loadPlugin({
                    url: getAdPluginPath(adPluginVersion),
                    globalName: adGlobalName,
                    pluginName: AdPluginName,
                    timeout: adScriptMaxLoadTime,
                    config: adInitConfig,
                    crossOrigin: 'anonymous',
                });
            }
        }
        return adInitDefer.then(function () {
            if (_this._destroyed) {
                return null;
            }
            if (!getAdPlugin(_this.config.instanceId) && H5Player.getPlugin(AdPluginName)) {
                _this.createPlugin(AdPluginName, adInitConfig);
            }
            return getAdPlugin(_this.instanceId);
        }).catch(function (error) {
            // 广告加载失败时直接播放正片即可
            // TODO：后续应该有相应的打击逻辑，比如广告插件js加载很快失败等场景
            _this.log("adPlugin load fail. ".concat(error === null || error === void 0 ? void 0 : error.message));
            return null;
        });
    };
    /**
     * 在重新播放前的清理工作。
     */
    SuperPlayer.prototype.clearBeforeReplay = function () {
        // 重新播放要清掉数据中心中跟广告信息相关数据，避免干扰下一次播放
        this.setCommonKv(SUPER_DATA_KEY.hlsAdRanges, null);
        this.setCommonKv(SUPER_DATA_KEY.getinfoAdInfo, null);
    };
    SuperPlayer.prototype.getBuiltInVideoReqInfoParam = function (playConfig, needAdInfo) {
        if (needAdInfo === void 0) { needAdInfo = true; }
        return __awaiter(this, void 0, void 0, function () {
            var getCommonKv, param, getinfoAdInfo, forceCodecFromUrl, needDegrade;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        getCommonKv = this.getCommonKv.bind(this);
                        if (!(this.type === PLAY_MODE.VOD)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getVodBuiltInVideoReqInfoParam(this.config, playConfig, getCommonKv)];
                    case 1:
                        param = _a.sent();
                        if (this._destroyed) {
                            return [2 /*return*/];
                        }
                        if (needAdInfo) {
                            getinfoAdInfo = getCommonKv(SUPER_DATA_KEY.getinfoAdInfo);
                            if (getinfoAdInfo) {
                                param.adsid = getinfoAdInfo.adsid || '';
                                param.adpinfo = getinfoAdInfo.adpinfo || '';
                            }
                        }
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, getLiveBuiltInVideoReqInfoParam(this.config, playConfig, getCommonKv)];
                    case 3:
                        param = _a.sent();
                        _a.label = 4;
                    case 4:
                        forceCodecFromUrl = +getForceCodecFromUrl();
                        needDegrade = readDegradeCodecFromLocal().needDegrade;
                        if (!!needDegrade || forceCodecFromUrl === PLAY_CODEC.H264) {
                            delete param.hevclv;
                            delete param.spav1;
                        }
                        else if (forceCodecFromUrl === PLAY_CODEC.H265) {
                            param.hevclv = HEVC_LV_VALUE.UHD;
                        }
                        return [2 /*return*/, param];
                }
            });
        });
    };
    /** debug属性，保存所有实例 */
    SuperPlayer._instances = {};
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "destroy", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "play", null);
    __decorate([
        performanceCost,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object, String]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "loadOrPlay", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "replay", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "load", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object, Number]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "preload", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "seek", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "setLevel", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "closePayTipsCallback", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "createPlugin", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "setAdConfig", null);
    __decorate([
        destroyProtectDecorator,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "requestProxyHttpOnlyAd", null);
    __decorate([
        destroyProtectDecorator,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "requestAdCallback4AdPlugin", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SuperPlayer.prototype, "stop", null);
    __decorate([
        performanceCost,
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], SuperPlayer.prototype, "getBuiltInVideoReqInfoParam", null);
    return SuperPlayer;
}(H5Player));
var BUILD_TIME = envVals.BUILD_TIME;
var VERSION = envVals.VERSION;
bindExports(SuperPlayer);
// 为了让插件cdn能够搭配 @tencent/super-player npm 包使用，这里需要挂载异步插件所需要的全局变量
mountGlobal({
    globalName: 'SuperPlayer',
    target: SuperPlayer,
    onDuplicate: function () {
        console.warn('Possible duplicated SuperPlayer detected. Avoid to import this package multiple times.');
    },
});
StepTimer.start(SuperStepKey.READY_2_NEW);
// 当superplayer.js模块初始化好了以后，就开始提前加载广告插件。避免在页面new播放器时才开始加载，遇到执行峰值。
adInitDefer = preloadAdPlugin();

export { BUILD_TIME, CtrlbarPluginName, ErrorPagePluginEvents, ErrorPagePluginName, InfoPanelPluginName, LOCAL_STORAGE_KEY, PLUGINS_URL, PosterPluginName, SUPER_DATA_KEY, SUPER_END_STATE, SUPER_EVENTS, SuperStepKey, TipsPluginName, UIContextMenuPluginName, VERSION, WatermarkPluginName, adGlobalName, adScriptMaxLoadTime, adVersion, contextMenuPluginName, ctrlbarPluginName, SuperPlayer as default, defaultLiveBusinessConfig, defaultSuperConfig, defaultVodBusinessConfig, defaultVodPlatform, defautVodSdtfrom, formatDefnName, getAdInitConfig, getAdPluginPath, getBuiltInPlugins, getLocalDynamicConfig, getSuperConfig, isInDomainWhiteList, mergeDynamicConfig, skipAdDomainWhiteList };
